import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { baseurImage, baseurl } from "../../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "react-multi-date-picker";
import dayjs from "dayjs";
import AnalogClock from "../../Component/Appointment2/AnalogClock";
import Swal from "sweetalert2";
import axiosInstance from "../../api/axiosInstance";
import AddAppointment from "../Manage Appointment/Appointment/Addappointment";
import { fetchModuleMappings, hasSubModulePermission, isAdmin } from "../../utils/permissions";
import "./Appointment2.css";

// Waiting bucket: green under 10 min, amber 10-20 min, red 20 min+.
function waitingBucketColor(elapsedSec) {
  const elapsedMin = elapsedSec / 60;
  if (elapsedMin < 10) return "#2CA87F"; // green
  if (elapsedMin < 20) return "#f39c12"; // amber
  return "#e74c3c"; // red
}

// Full ARRIVED badge: background color escalates (green → amber → red) every 10 min of waiting.
function ArrivedBadge({ arrivalTime, freezeAt }) {
  const [now, setNow] = useState(Date.now());
  const isFrozen = !!freezeAt;

  useEffect(() => {
    if (isFrozen) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [isFrozen]);

  if (!arrivalTime) return null;
  const arrivedMs = new Date(arrivalTime).getTime();
  if (Number.isNaN(arrivedMs)) return null;

  const endMs = isFrozen ? new Date(freezeAt).getTime() : now;
  const elapsedSec = Math.max(0, Math.floor((endMs - arrivedMs) / 1000));
  const h = Math.floor(elapsedSec / 3600);
  const m = Math.floor((elapsedSec % 3600) / 60);
  const s = elapsedSec % 60;
  const label = h > 0
    ? `${h}:${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`
    : `${m}:${String(s).padStart(2, "0")}`;

  return (
    <span style={{
      fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
      background: waitingBucketColor(elapsedSec), color: "#fff", letterSpacing: "0.04em",
    }}>
      <i className="ti ti-door-enter me-1" style={{ fontSize: 10 }} />ARRIVED
      <span style={{ marginLeft: 5, fontWeight: 700 }}>· {label}</span>
    </span>
  );
}

export default function Appointment2() {
  const [modalopen, setModalOpen] = useState(false);
  const [waitngData, setWaitngData] = useState([]);
  const [openmodal, setOpenmodal] = useState(false);
  const [showNewAppointmentModal, setShowNewAppointmentModal] = useState(false);
  const [newAppointmentPrefill, setNewAppointmentPrefill] = useState(null);
  const [canAddAppointment, setCanAddAppointment] = useState(true);
  const [selectedDoctors, setSelectedDoctors] = useState([]);
  const [arrayuser, setArrayuser] = useState([]);
  const initialLoadStartedRef = useRef(false);
  const [appointviewdata, setAppointviewdata] = useState("");
  const [showModalDoctor, setShowModalDoctor] = useState(false);
  const [showModalDoctor23, setShowModalDoctor23] = useState(false);
  const [showModaledit, setShowModaledit] = useState(false);
  const [searchTerm, setSearchTerm] = useState(() => localStorage.getItem('appt_searchTerm') || "");
  const [statusFilter, setStatusFilter] = useState(() => localStorage.getItem('appt_statusFilter') || "pending"); // "all" | "pending" | "completed"
  useEffect(() => {
    localStorage.setItem('appt_searchTerm', searchTerm);
  }, [searchTerm]);
  useEffect(() => {
    localStorage.setItem('appt_statusFilter', statusFilter);
  }, [statusFilter]);
  const allBranchSettings = useSelector((state) => state.business.allBranchSettings);
  const activeBranchId = useSelector((state) => state.business.activeBranchId);
  const [branchFilter, setBranchFilter] = useState(() => {
    const id = activeBranchId || parseInt(localStorage.getItem('activeBranchId'));
    return id ? String(id) : "all";
  });
  useEffect(() => {
    if (allBranchSettings && allBranchSettings.length <= 1) {
      setBranchFilter("all");
    }
  }, [allBranchSettings]);
  const [selectedDates, setSelectedDates] = useState(() => {
    try {
      const s = localStorage.getItem('appt_selectedDates');
      if (s) return JSON.parse(s).map(d => dayjs(d));
    } catch {}
    return [];
  });
  const [appointmentpatiemt, setAppointmentPatient] = useState([]);
  const [waitingRoomOpen, setWaitingRoomOpen] = useState(false);
  const [waitingRoomList, setWaitingRoomList] = useState([]);
  const [appointmentdata1, setAppointmentdata1] = useState({});
  const [showdata, setShowdata] = useState(() => localStorage.getItem('appt_viewMode') === 'list');
  const [viewMode, setViewMode] = useState(() => localStorage.getItem('appt_viewMode') || 'card');
  // Phones (<=768px) are locked to Card view — Calendar/List aren't usable at that width.
  const [isMobilePhone, setIsMobilePhone] = useState(() => window.innerWidth <= 768);
  const [videwmodapopen, setVidewmodapopen] = useState(false);
  const [eid, setEid] = useState("");
  const [doctorsdata, setDoctorsdata] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [dataConfirm, setDataConfirm] = useState("");
  const [datamodalappointment, setDatamodalappointment] = useState("");
  const [waitingRecord, setWaitingRecord] = useState(null);
  const [modalNoShowRisk, setModalNoShowRisk] = useState(null);
  const [calledIds, setCalledIds] = useState(new Set());
  const [callTimes, setCallTimes] = useState({});
  const [arrivedIds, setArrivedIds] = useState(new Set());
  const [arrivalTimes, setArrivalTimes] = useState({});
  const [doctors, setDoctors] = useState("");
  const [allowedDoctorIds, setAllowedDoctorIds] = useState([]); // IDs this user is permitted to see (empty = no restriction)
  const [appointmentdata, setAppointmentdata] = useState([]);
  const [appointmentdata12, setAppointmentdata12] = useState([]);
  const [duplicateArray, setDuplicateArray] = useState([]);
  const [selectAll, setSelectAll] = useState();
  const [selectedDate, setSelectedDate] = useState(() => {
    const s = localStorage.getItem('appt_selectedDate');
    return s ? dayjs(s) : null;
  });
  const [currentPage, setCurrentPage] = useState(1);
  // sms log modal
  const [smsLogOpen, setSmsLogOpen] = useState(false);
  const [smsLogs, setSmsLogs] = useState([]);
  const [smsLogLoading, setSmsLogLoading] = useState(false);
  const [smsLogFilter, setSmsLogFilter] = useState("all"); // "all" | "sent" | "failed"

  // Waiting → Book modal
  const [waitingItem, setWaitingItem] = useState(null);
  const [bookModalBookedSlots, setBookModalBookedSlots] = useState([]);
  const [bookModalLoadingSlots, setBookModalLoadingSlots] = useState(false);
  const [bookModalTimeMode, setBookModalTimeMode] = useState("slots");

  // Edit appointment modal
  const [editModalBookedSlots, setEditModalBookedSlots] = useState([]);
  const [editModalLoadingSlots, setEditModalLoadingSlots] = useState(false);
  const [editModalTimeMode, setEditModalTimeMode] = useState("slots");
  // Snapshot of status as loaded, so we only touch the status endpoint if the
  // user actually changed Type - avoids reverting a Completed/Cancelled/
  // Confirmed appointment back to "Booked" just because its date/time was edited.
  const [editModalOriginalStatus, setEditModalOriginalStatus] = useState("");

  // online appointment
  const [onlineModalOpen, setOnlineModalOpen] = useState(false);
  const [onlineData, setOnlineData] = useState([]);
  const [onlineSearchText, setOnlineSearchText] = useState("");
  // Add this state to track pending online appointments count
  const [pendingOnlineCount, setPendingOnlineCount] = useState(0);





  // ✅ NEW: Online booking confirmation modal ke liye
  const [onlineBookingModal, setOnlineBookingModal] = useState(false);
  const [selectedOnlineAppointment, setSelectedOnlineAppointment] = useState(null);
  const [onlineBookingData, setOnlineBookingData] = useState({
    doctorId: "",
    startTime: "",
    endTime: "",
    date: ""
  });

  // Force Schedule module state
  const [forceScheduleEnabled, setForceScheduleEnabled] = useState(false);
  const [doctorScheduleSlots, setDoctorScheduleSlots] = useState([]);
  const [scheduleLoading, setScheduleLoading] = useState(false);
  const [isDayOff, setIsDayOff] = useState(false);

  // Doctor week availability modal
  const [allDoctorsMap, setAllDoctorsMap] = useState({});
  const [doctorWeekModal, setDoctorWeekModal] = useState(false);
  const [doctorWeekInfo, setDoctorWeekInfo] = useState(null);
  const [doctorWeekLoading, setDoctorWeekLoading] = useState(false);


  const itemsPerPage = 10;
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ NEW: Patient Selection & Search Flow
  const [bookingTypeModal, setBookingTypeModal] = useState(false);
  const [patientSearchModal, setPatientSearchModal] = useState(false);
  const [allPatients, setAllPatients] = useState([]);
  const [patientSearchTerm, setPatientSearchTerm] = useState("");
  const [selectedPatient, setSelectedPatient] = useState(null);

  // ✅ NEW: Handle returning from Add Patient page (success or cancel)
  useEffect(() => {
    const onlineFlowActive = sessionStorage.getItem("onlineFlowActive");
    const pendingOnlineBooking = localStorage.getItem("pendingOnlineBooking");

    // Check navigation state for newly created patient
    const fromNewPatient = location.state?.newPatientCreated || localStorage.getItem("returnFromAddPatient");
    const newlyRegisteredPatientId = location.state?.patientId || localStorage.getItem("newlyRegisteredPatientId");
    const newlyRegisteredPatientName = location.state?.patientName || localStorage.getItem("newlyRegisteredPatientName");

    if (onlineFlowActive && pendingOnlineBooking) {
      setOnlineModalOpen(true);
      fetchOnlineAppointments();

      if (fromNewPatient) {
        const bookingData = location.state?.onlineAppointmentData || JSON.parse(pendingOnlineBooking);

        // Update selectedOnlineAppointment with patient details
        const updatedBookingData = {
          ...bookingData,
          patientId: newlyRegisteredPatientId,
          patientName: newlyRegisteredPatientName
        };
        setSelectedOnlineAppointment(updatedBookingData);

        // Auto-fill booking data with new patient
        setOnlineBookingData(prev => ({
          ...prev,
          doctorId: "",
          startTime: bookingData.appointmentStartTime?.slice(0, 5) || "",
          endTime: bookingData.appointmentEndTime?.slice(0, 5) || "",
          date: bookingData.appointmentDate || "",
          patientId: newlyRegisteredPatientId || ""
        }));

        if (newlyRegisteredPatientId) {
          setSelectedPatient({
            id: newlyRegisteredPatientId,
            name: newlyRegisteredPatientName || "Newly Registered Patient"
          });
        }

        setOnlineBookingModal(true);

        // Clear flags
        localStorage.removeItem("returnFromAddPatient");
        localStorage.removeItem("newlyRegisteredPatientId");
        localStorage.removeItem("newlyRegisteredPatientName");
        // Clear location state if used
        if (location.state?.newPatientCreated) {
          navigate('/Admin/appointment2', { replace: true, state: {} });
        }
      }
    }
  }, [location.state]);

  const handleclickmodal = () => {
    setModalOpen(true);
  };
  const handleclose = () => {
    setModalOpen(false);
    waitingAppointmentList1();
  };
  useEffect(() => {
    waitingAppointmentList1();
  }, []);
  useEffect(() => {
    fetchDoctors();
  }, []);
  useEffect(() => {
    const checkAddAppointmentPermission = async () => {
      if (isAdmin()) {
        setCanAddAppointment(true);
        return;
      }

      try {
        const allModules = await fetchModuleMappings();
        const appointmentsModule = allModules.find(m => m.module_name === 'appointments');
        const addAppointmentSub = appointmentsModule?.sub_modules?.find(
          sm => sm.sub_module_name === 'Add_Appointment'
        );

        setCanAddAppointment(addAppointmentSub ? hasSubModulePermission(addAppointmentSub.id) : false);
      } catch (err) {
        console.error("Error checking Add Appointment permission", err);
        setCanAddAppointment(false);
      }
    };

    checkAddAppointmentPermission();
  }, []);
  useEffect(() => {
    // Guard against a duplicate concurrent call (e.g. React StrictMode's double-invoked
    // mount effect in dev) racing itself and overwriting the first response with a second,
    // which is what caused appointments to flash in and then disappear a moment later.
    if (initialLoadStartedRef.current) return;
    initialLoadStartedRef.current = true;
    getpresavedroctor();
  }, []);

  useEffect(() => {
    fetchOnlineAppointments();
  }, [])

  // Persist view mode and date selections so they survive navigation away and back.
  // Skipped while locked to Card on a phone, so the forced switch never overwrites
  // the desktop/tablet user's saved preference.
  useEffect(() => {
    if (isMobilePhone) return;
    localStorage.setItem('appt_viewMode', viewMode);
  }, [viewMode, isMobilePhone]);

  // Track viewport width and force Card view whenever we're on a phone.
  useEffect(() => {
    const onResize = () => setIsMobilePhone(window.innerWidth <= 768);
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
      window.removeEventListener('orientationchange', onResize);
    };
  }, []);

  useEffect(() => {
    if (isMobilePhone && (showdata || viewMode !== 'card')) {
      setShowdata(false);
      setViewMode('card');
    }
  }, [isMobilePhone, showdata, viewMode]);

  useEffect(() => {
    if (selectedDate) {
      const fmt = selectedDate.format
        ? selectedDate.format('YYYY-MM-DD')
        : dayjs(selectedDate.toDate()).format('YYYY-MM-DD');
      localStorage.setItem('appt_selectedDate', fmt);
    }
  }, [selectedDate]);

  useEffect(() => {
    if (selectedDates && selectedDates.length > 0) {
      try {
        const arr = selectedDates.map(d =>
          d.format ? d.format('YYYY-MM-DD') : dayjs(d.toDate()).format('YYYY-MM-DD')
        );
        localStorage.setItem('appt_selectedDates', JSON.stringify(arr));
      } catch {}
    }
  }, [selectedDates]);

  useEffect(() => {
    axiosInstance.get('getModuleSettings').then(res => {
      if (res.data?.success) {
        const fs = res.data.data.find(r => r.module_name === 'force_schedule');
        if (fs) setForceScheduleEnabled(Boolean(fs.enable));
      }
    }).catch(() => {});
  }, []);

  useEffect(() => {
    axiosInstance.get('getAllDoctors').then(res => {
      if (res.data?.success) {
        const map = {};
        res.data.data.forEach(d => { map[String(d.id)] = d; });
        setAllDoctorsMap(map);
      }
    }).catch(() => {});
  }, []);

  // Fetch booked slots when book modal doctor/date changes
  useEffect(() => {
    if (!openmodal || !dataConfirm?.doctorId || !dataConfirm?.date) {
      setBookModalBookedSlots([]);
      return;
    }
    setBookModalLoadingSlots(true);
    axiosInstance.post('getAppointmentsByDoctorAndDate', {
      startDate: dataConfirm.date,
      endDate: dataConfirm.date,
      doctorIds: [dataConfirm.doctorId],
    }).then(res => {
      if (res.data?.success) setBookModalBookedSlots(res.data.data || []);
    }).catch(() => {}).finally(() => setBookModalLoadingSlots(false));
  }, [openmodal, dataConfirm?.doctorId, dataConfirm?.date]);

  // Fetch booked slots when edit-appointment modal doctor/date changes
  // (excludes the appointment being edited so its own current slot isn't shown as booked)
  useEffect(() => {
    const editDate = appointmentdata1?.appointmentDate
      ? dayjs(appointmentdata1.appointmentDate).format('YYYY-MM-DD')
      : '';
    if (!showModaledit || !appointmentdata1?.doctorId || !editDate) {
      setEditModalBookedSlots([]);
      return;
    }
    setEditModalLoadingSlots(true);
    axiosInstance.post('getAppointmentsByDoctorAndDate', {
      startDate: editDate,
      endDate: editDate,
      doctorIds: [appointmentdata1.doctorId],
    }).then(res => {
      if (res.data?.success) {
        const slots = (res.data.data || []).filter(d => String(d.id) !== String(appointmentdata1.id));
        setEditModalBookedSlots(slots);
      }
    }).catch(() => {}).finally(() => setEditModalLoadingSlots(false));
  }, [showModaledit, appointmentdata1?.doctorId, appointmentdata1?.appointmentDate, appointmentdata1?.id]);


  const toMins = (hhmm) => {
    if (!hhmm) return 0;
    const [h, m] = hhmm.slice(0, 5).split(':').map(Number);
    return h * 60 + m;
  };
  const fromMins = (mins) => {
    const h = Math.floor(mins / 60).toString().padStart(2, '0');
    const m = (mins % 60).toString().padStart(2, '0');
    return `${h}:${m}`;
  };
  const toAmPmW = (hhmm) => {
    if (!hhmm) return '';
    const [h, m] = hhmm.split(':').map(Number);
    const period = h < 12 ? 'AM' : 'PM';
    const hour = h % 12 === 0 ? 12 : h % 12;
    return `${hour}:${m.toString().padStart(2, '0')} ${period}`;
  };
  // Fetch called / arrived IDs and update state.
  // Pass a date string (YYYY-MM-DD) to scope to that day, or omit to load all.
  const fetchStatusIds = (date) => {
    const params = date ? { date } : {};
    axiosInstance.get('getCalledAppointmentIds', { params })
      .then(r => {
        setCalledIds(new Set(r.data?.data || []));
        setCallTimes(r.data?.callTimes || {});
      })
      .catch(() => {});
    axiosInstance.get('getArrivedAppointmentIds', { params })
      .then(r => {
        setArrivedIds(new Set(r.data?.data || []));
        setArrivalTimes(r.data?.arrivals || {});
      })
      .catch(() => {});
    fetchWaitingRoomList(date);
  };

  // Everyone currently ARRIVED (waiting room), across ALL doctors — never scoped to the
  // doctor filter selected in the main view, so reception sees the full physical waiting room.
  const fetchWaitingRoomList = (date) => {
    const params = date ? { date } : {};
    axiosInstance.get('getWaitingRoomAppointments', { params })
      .then(r => setWaitingRoomList(r.data?.data || []))
      .catch(() => {});
  };

  const bookAllTimeSlots = (() => {
    const slots = [];
    for (let m = 0; m < 24 * 60; m += 10) slots.push(fromMins(m));
    return slots;
  })();

  const openDoctorWeekModal = async (doc) => {
    const docId = doc.id ?? doc.doctorId; // grouped response uses doctorId, flat uses id
    const doctorFull = allDoctorsMap[String(docId)] || doc;
    const days = Array.from({ length: 7 }, (_, i) => dayjs().add(i, 'day'));
    setDoctorWeekInfo({ doctor: doctorFull, days, schedule: [], appointments: [] });
    setDoctorWeekModal(true);
    setDoctorWeekLoading(true);
    try {
      const monthsNeeded = [...new Set(days.map(d => `${d.year()}-${d.month() + 1}`))];
      const scheduleResults = await Promise.all(
        monthsNeeded.map(ym => {
          const [y, m] = ym.split('-');
          return axiosInstance.get(`getDoctorDateSchedule/${docId}?year=${y}&month=${m}`)
            .then(r => r.data?.success ? r.data.data : []).catch(() => []);
        })
      );
      const allSchedule = scheduleResults.flat();
      const apptRes = await axiosInstance.post('getAppointmentsByDoctorAndDate', {
        startDate: days[0].format('YYYY-MM-DD'),
        endDate: days[6].format('YYYY-MM-DD'),
        doctorIds: [docId],
      });
      const bookedAppts = apptRes.data?.success ? apptRes.data.data : [];
      setDoctorWeekInfo({ doctor: doctorFull, days, schedule: allSchedule, appointments: bookedAppts });
    } catch (e) {
      setDoctorWeekInfo(prev => ({ ...prev, schedule: [], appointments: [] }));
    } finally {
      setDoctorWeekLoading(false);
    }
  };

  const getpresavedroctor = async () => {
    const userid = JSON.parse(localStorage.getItem("userMedical"));
    const userid11 = JSON.parse(localStorage.getItem("userarray"));
    try {
      const response = await axiosInstance.get(
        `getSelectedDoctors/${userid?.data?.id}`
      );
      if (response.data.success === true) {
        const allowedIds = (response.data.allowedDoctorIds || []).map(String);
        const savedFilter = response.data.filterDoctorIds; // null = no user preference yet

        // allowedDoctorIds controls what's visible in the filter modal (admin-set, never overwritten by user)
        setAllowedDoctorIds(allowedIds);

        // User's active filter: use their saved preference trimmed to allowed, else default to all allowed
        const initialFilter = savedFilter !== null
          ? savedFilter.map(String).filter(id => allowedIds.length === 0 || allowedIds.includes(id))
          : allowedIds;

        setSelectedDoctors(initialFilter);
        setArrayuser(initialFilter);
        setSelectAll(initialFilter.length === allowedIds.length && allowedIds.length > 0);

        // Fetch data for the persisted date/range (or today if none saved)
        if (initialFilter.length > 0) {
          localStorage.setItem("userarray", JSON.stringify({ data: initialFilter }));
          try {
            // Fetch fresh doctor list to avoid stale-closure issue when doctors state isn't loaded yet
            let freshDoctorsList = doctors && doctors.length > 0 ? doctors : [];
            if (freshDoctorsList.length === 0) {
              try {
                const docRes = await axiosInstance.get('getActiveDoctors');
                if (docRes.data?.success) {
                  freshDoctorsList = docRes.data.data;
                  setDoctors(freshDoctorsList);
                }
              } catch {}
            }
            const restoredMode = localStorage.getItem('appt_viewMode') || 'card';
            let sDate, eDate, source;
            if (restoredMode === 'list') {
              try {
                const saved = localStorage.getItem('appt_selectedDates');
                if (saved) {
                  const parsed = JSON.parse(saved);
                  sDate = parsed[0] || dayjs().format('YYYY-MM-DD');
                  eDate = parsed[1] || sDate;
                  source = 'range';
                }
              } catch {}
            }
            if (!sDate) {
              sDate = localStorage.getItem('appt_selectedDate') || dayjs().format('YYYY-MM-DD');
              eDate = sDate;
              source = 'single';
            }
            await syncFiltersAndFetch(sDate, eDate, initialFilter, source, freshDoctorsList);
          } catch (error) {
            console.error("Error fetching filtered data on initial load:", error);
          }
        } else {
          // No restriction and no preference — clear stale filter key and load all appointments
          localStorage.removeItem("userarray");
          await getdata();
        }
      } else {
        console.error("Failed to fetch saved doctors");
        await fallbackInitialLoad(userid11);
      }
    } catch (error) {
      console.error("Error fetching saved doctors:", error);
      await fallbackInitialLoad(userid11);
    }
  };

  // getSelectedDoctors failed/errored — fall back to the last-known filter (or all data)
  // instead of leaving the page empty until the user clicks search.
  const fallbackInitialLoad = async (persistedUserarray) => {
    const fallbackIds = Array.isArray(persistedUserarray?.data) ? persistedUserarray.data.map(String) : [];
    if (fallbackIds.length > 0) {
      setSelectedDoctors(fallbackIds);
      setArrayuser(fallbackIds);
      const restoredMode = localStorage.getItem('appt_viewMode') || 'card';
      let sDate, eDate, source;
      if (restoredMode === 'list') {
        try {
          const saved = localStorage.getItem('appt_selectedDates');
          if (saved) {
            const parsed = JSON.parse(saved);
            sDate = parsed[0] || dayjs().format('YYYY-MM-DD');
            eDate = parsed[1] || sDate;
            source = 'range';
          }
        } catch {}
      }
      if (!sDate) {
        sDate = localStorage.getItem('appt_selectedDate') || dayjs().format('YYYY-MM-DD');
        eDate = sDate;
        source = 'single';
      }
      try {
        await syncFiltersAndFetch(sDate, eDate, fallbackIds, source, doctors);
      } catch {
        await getdata();
      }
    } else {
      await getdata();
    }
  };
  const waitingAppointmentList1 = async () => {
    try {
      const response = await axiosInstance.get(`getWaitingAppointments`);
      if (response.data.success === true) {
        setWaitngData(response.data.data);
      } else {
        console.error("some thing went wrong");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getdata = async () => {
    try {
      const response = await axiosInstance.get(`getAllAppointments`);
      if (response.data.success === true) {
        setAppointmentdata12(response.data.data);
        setAppointmentdata(response.data.data);
        setDuplicateArray(response.data.data);
      } else {
        console.error("something went wrong");
      }
    } catch (error) {
      console.error(error);
    }
  };
  const handleclick = (id, item) => {
    setEid(id);
    setWaitingItem(item || null);
    setBookModalTimeMode("slots");
    setBookModalBookedSlots([]);
    setDataConfirm({
      doctorId: item?.doctorId ? String(item.doctorId) : '',
      date: item?.appointmentDate ? dayjs(item.appointmentDate).format('YYYY-MM-DD') : dayjs().format('YYYY-MM-DD'),
      startTime: '',
      endTime: '',
    });
    setOpenmodal(true);
  };
  const handleclose22 = () => {
    setOpenmodal(false);
  };
  useEffect(() => {
    getallActiveDoctor();
  }, []);
  const getallActiveDoctor = async () => {
    const response = await axiosInstance.get(`getActiveDoctors`);
    setDoctorsdata(response.data.data);
  };
  const handlechange = (e) => {
    const { name, value } = e.target;
    setDataConfirm({ ...dataConfirm, [name]: value });
  };
  const handlechange11 = (e) => {
    const value = e.target.value;
    const checked = e.target.checked;
    setSelectedDoctors((prevSelected) => {
      let updated;
      if (checked) {
        updated = [...prevSelected, value];
      } else {
        updated = prevSelected.filter((id) => id !== value);
      }
      setSelectAll(updated.length === doctors.length);
      setArrayuser(updated);
      localStorage.setItem("userarray", JSON.stringify({ data: updated }));
      return updated;
    });
  };

  // ✅ NEW: Fetch Online Appointments
  const fetchOnlineAppointments = async () => {
    try {
      const response = await axiosInstance.get(`getOnlineAppointment`);
      if (response.data.success === true) {
        setOnlineData(response.data.data || []);
      } else {
        console.error("Failed to fetch online appointments");
        setOnlineData([]);
      }
    } catch (error) {
      console.error("Error fetching online appointments:", error);
      setOnlineData([]);
    }
  };


  // ✅ NEW: Close booking confirmation modal
  const handleCloseOnlineBookingModal = () => {
    setOnlineBookingModal(false);
    setSelectedOnlineAppointment(null);
    setOnlineBookingData({
      doctorId: "",
      startTime: "",
      endTime: "",
      date: ""
    });
  };


  // ✅ NEW: Handle Book button click - opens selection modal
  const handleOnlineBookClick = (item) => {
    setSelectedOnlineAppointment(item);
    setBookingTypeModal(true);
  };

  // ✅ NEW: Handle Booking Type Selection
  const handleBookingTypeSelection = async (type) => {
    setBookingTypeModal(false);

    if (type === "new") {
      // Store current appointment data to pre-fill Add Patient page
      localStorage.setItem("pendingOnlineBooking", JSON.stringify(selectedOnlineAppointment));
      sessionStorage.setItem("onlineFlowActive", "true");
      setOnlineModalOpen(false); // Close modaler for cleaner transition
      navigate("/Admin/addPatient");
    } else {
      // Existing Patient - Show Search Modal
      setPatientSearchModal(true);
      fetchPatientsForSearch();
    }
  };

  // ✅ NEW: Fetch patients for search modal
  const fetchPatientsForSearch = async () => {
    try {
      const response = await axiosInstance.get("getAllPatients");
      if (response.data.success) {
        setAllPatients(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching patients:", error);
    }
  };

  // ✅ NEW: Handle selecting an existing patient
  const handleSelectExistingPatient = (patient) => {
    setSelectedPatient({
      id: patient.id,
      name: `${patient.firstName} ${patient.lastName}`
    });

    // Set booking data with existing patient ID
    setOnlineBookingData({
      doctorId: "",
      startTime: selectedOnlineAppointment.appointmentStartTime?.slice(0, 5) || "",
      endTime: selectedOnlineAppointment.appointmentEndTime?.slice(0, 5) || "",
      date: selectedOnlineAppointment.appointmentDate || "",
      patientId: patient.id
    });

    setPatientSearchModal(false);
    setOnlineBookingModal(true);
  };


  // ✅ NEW: Confirm and book online appointment
  const confirmOnlineBooking = async () => {
    // Validation
    if (isDayOff) {
      Swal.fire({ icon: "warning", title: "Unavailable", text: "Doctor is marked as unavailable on this date" });
      return;
    }
    if (!onlineBookingData.doctorId) {
      Swal.fire({ icon: "warning", title: "Required", text: "Please select a doctor" });
      return;
    }
    if (!onlineBookingData.date) {
      Swal.fire({ icon: "warning", title: "Required", text: "Please select a date" });
      return;
    }
    if (!onlineBookingData.startTime) {
      Swal.fire({ icon: "warning", title: "Required", text: "Please select start time" });
      return;
    }
    if (!onlineBookingData.endTime) {
      Swal.fire({ icon: "warning", title: "Required", text: "Please select end time" });
      return;
    }

    // Time validation
    const start = new Date(`2020-01-01T${onlineBookingData.startTime}`);
    const end = new Date(`2020-01-01T${onlineBookingData.endTime}`);

    if (end <= start) {
      Swal.fire({ icon: "error", title: "Invalid Time", text: "End time must be after start time" });
      return;
    }

    const datapost = {
      doctorId: onlineBookingData.doctorId,
      date: onlineBookingData.date,
      startTime: onlineBookingData.startTime,
      endTime: onlineBookingData.endTime,
      reason: selectedOnlineAppointment?.appointmentServiceName,
      patientId: selectedOnlineAppointment?.patientId || selectedPatient?.id || onlineBookingData.patientId || ""
    };

    try {
      const response = await axiosInstance.post(
        `onlineBookingAppointment/${selectedOnlineAppointment.appointmentId}`,
        datapost
      );

      if (response.data.success === true) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Appointment booked successfully",
        });

        // Clear pending booking data
        localStorage.removeItem("pendingOnlineBooking");
        setSelectedPatient(null);

        handleCloseOnlineBookingModal();
        fetchOnlineAppointments(); // Refresh online list
        waitingAppointmentList1(); // Refresh waiting list

        // Refresh main view
        const userid11 = JSON.parse(localStorage.getItem("userarray"));
        const freshDoctorIds = userid11?.data || [];

        if (freshDoctorIds.length > 0) {
          let sDate, eDate, source;
          if (showdata) {
            if (selectedDates?.length > 0) {
              sDate = selectedDates[0].format("YYYY-MM-DD");
              eDate = selectedDates[1]?.format("YYYY-MM-DD") || sDate;
            } else {
              sDate = dayjs().format("YYYY-MM-DD");
              eDate = sDate;
            }
            source = 'range';
          } else {
            sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
            eDate = sDate;
            source = 'single';
          }
          await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);
        } else {
          await getdata();
        }

      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.data.message || "Unable to book appointment",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: error.response?.data?.message || "Something went wrong",
      });
    }
  };


  // Add this useEffect to calculate pending count whenever onlineData changes
  useEffect(() => {
    if (onlineData && onlineData.length > 0) {
      const pendingCount = onlineData.filter(
        item => item.appointmentStatus === "Pending"
      ).length;
      setPendingOnlineCount(pendingCount);
    } else {
      setPendingOnlineCount(0);
    }
  }, [onlineData]);



  // Fetch doctor schedule for selected date when force_schedule is enabled
  useEffect(() => {
    if (!forceScheduleEnabled || !onlineBookingData.doctorId || !onlineBookingData.date) {
      setDoctorScheduleSlots([]);
      setIsDayOff(false);
      return;
    }
    const d = dayjs(onlineBookingData.date);
    setScheduleLoading(true);
    setDoctorScheduleSlots([]);
    setIsDayOff(false);
    setOnlineBookingData(prev => ({ ...prev, startTime: '', endTime: '' }));
    axiosInstance.get(`getDoctorDateSchedule/${onlineBookingData.doctorId}?year=${d.year()}&month=${d.month() + 1}`)
      .then(res => {
        if (res.data?.success) {
          const dateStr = d.format('YYYY-MM-DD');
          const dayEntries = res.data.data.filter(e => (e.schedule_date || '').slice(0, 10) === dateStr);
          const dayOffEntry = dayEntries.some(e => e.is_day_off);
          setIsDayOff(dayOffEntry);
          setDoctorScheduleSlots(dayOffEntry ? [] : dayEntries);
        }
      })
      .catch(() => {})
      .finally(() => setScheduleLoading(false));
  }, [forceScheduleEnabled, onlineBookingData.doctorId, onlineBookingData.date]);

  // ✅ NEW: Handle form input changes
  const handleOnlineBookingChange = (e) => {
    const { name, value } = e.target;
    setOnlineBookingData(prev => ({ ...prev, [name]: value }));
  };

  const openSmsLog = async () => {
    setSmsLogOpen(true);
    setSmsLogLoading(true);
    try {
      const res = await axiosInstance.get('getSmsLogs?limit=200');
      setSmsLogs(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch {
      setSmsLogs([]);
    } finally {
      setSmsLogLoading(false);
    }
  };

  // ✅ NEW: Handle Online Booking button click
  const handleOnlineBookingClick = () => {
    setOnlineModalOpen(true);
    fetchOnlineAppointments();
  };

  // ✅ NEW: Close online modal
  const handleCloseOnlineModal = () => {
    setOnlineModalOpen(false);
  };

  const bookOnlineAppointment = async (item) => {
    try {
      const response = await axiosInstance.post(
        `updateOnlineAppointmentStatus/${item.appointmentId}`,
        { status: "Approved" }
      );

      if (response.data.success === true) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Appointment approved successfully.",
        });
        fetchOnlineAppointments(); // Refresh list (Pending wale hat jayenge)
        waitingAppointmentList1(); // Waiting list bhi refresh
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.data.message || "Unable to approve appointment.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text: error.response?.data?.message || "Something went wrong.",
      });
    }
  };

  // ✅ Cancel (Cancelled) - Same API endpoint
  const cancelOnlineAppointment = async (appointmentId) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
    });

    if (confirm.isConfirmed) {
      try {
        const response = await axiosInstance.post(
          `updateOnlineAppointmentStatus/${appointmentId}`,
          { status: "Cancelled" }
        );

        if (response.data.success === true) {
          Swal.fire("Cancelled!", "Appointment has been cancelled.", "success");
          fetchOnlineAppointments(); // Refresh list
        }
      } catch (error) {
        Swal.fire("Error!", "Something went wrong while cancelling.", "error");
      }
    }
  };



  const handleSelectAll = (e) => {
    const checked = e.target.checked;
    setSelectAll(checked);
    if (checked) {
      const allDoctorIds = doctors.map((doc) => String(doc.id));
      setSelectedDoctors(allDoctorIds);
      setArrayuser(allDoctorIds);
      localStorage.setItem("userarray", JSON.stringify({ data: allDoctorIds }));
      // fetchAllDoctorsData(allDoctorIds);
    } else {
      setSelectedDoctors([]);
      setArrayuser([]);
      localStorage.removeItem("userarray");
      // clearAllFilters();
    }
  };
  useEffect(() => {
    if (doctors.length === 0) return;
    const allDoctorIds = doctors.map((doc) => String(doc.id));
    setSelectAll(
      allDoctorIds.length > 0 &&
      allDoctorIds.every((id) => selectedDoctors.includes(id))
    );
  }, [doctors, selectedDoctors]);
  const handleSelectAll123 = (e) => {
    const checked = e.target.checked;

    setSelectAll(checked);

    if (checked) {
      const allDoctorIds = doctors.map((doc) => String(doc.id));

      setSelectedDoctors(allDoctorIds);
      setArrayuser(allDoctorIds);

      // ✅ FIX: Update localStorage immediately
      localStorage.setItem("userarray", JSON.stringify({ data: allDoctorIds }));



    } else {
      setSelectedDoctors([]);
      setArrayuser([]);
      localStorage.removeItem("userarray");
    }
  };
  const [allAppointments, setAllAppointments] = useState([]);
  const [noShowRiskById, setNoShowRiskById] = useState({});
  const setFunction123 = () => {

    const userid11 = JSON.parse(localStorage.getItem("userarray"));
    const sourceArray =
      duplicateArray?.length > 0 ? duplicateArray : allAppointments;
    if (arrayuser.length > 0) {
      const filteredAppointments = sourceArray.filter((appointment) =>
        arrayuser.includes(String(appointment.doctorId))
      );
      if (filteredAppointments.length > 0) {
        setAppointmentdata12(filteredAppointments);
      } else {
        console.warn("No appointments found for selected doctors");
        setAppointmentdata12([]); // clear view if no matches
      }
    } else {
      console.warn("No doctor selected → showing all appointments");
      setAppointmentdata12(sourceArray);
    }
    handlelcicktoope1111nFALSE();
  };
  const setFunction = async (passedDoctorIds) => {

    const idsToUse = passedDoctorIds || arrayuser;

    if (!idsToUse || idsToUse.length === 0) {
      console.warn("No doctor IDs found. Showing all appointments.");

      setAppointmentdata12(duplicateArray.length > 0 ? duplicateArray : allAppointments);
      return;
    }

    try {
      const response = await axiosInstance.post(`appointmentByDoctorId`, {
        doctorIds: idsToUse,
      });
      if (response.data.success === true) {
        setAppointmentPatient(response.data.data);
        setAppointmentdata(response.data.data);
        setAppointmentdata12(response.data.data);
        setDuplicateArray(response.data.data);
        fetchStatusIds();
      } else {
        console.error("Something went wrong");
      }
    } catch (error) {
      console.error("Error:", error);
      Swal.fire("Error", "Failed to filter appointments", "error");
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                       SINGLE SOURCE OF TRUTH LOGIC                         */
  /* -------------------------------------------------------------------------- */

  /**
   * Universal function to fetch and sync data for both views
   * @param {string} sDate - Start Date (YYYY-MM-DD)
   * @param {string} eDate - End Date (YYYY-MM-DD)
   * @param {Array} docIds - Array of Doctor IDs
   * @param {string} source - 'range' (List View) or 'single' (Calendar View)
   */
  const syncFiltersAndFetch = async (sDate, eDate, docIds, source, doctorsList) => {
    // 1. Determine active doctor IDs
    const doctorIds = docIds && docIds.length > 0 ? docIds : arrayuser;

    // 2. Logic for Calendar Date (Fallback to Today if Range)
    let calDate = sDate;
    let isRange = false;
    if (sDate !== eDate) {
      calDate = dayjs().format("YYYY-MM-DD");
      isRange = true;
    }

    // 3. Update Sync UI States (Visual Sync)
    // If Source is 'range' (List View), update Calendar State
    if (source === "range") {
      if (isRange) {
        // If it's a true range, Calendar falls back to Today
        setSelectedDate(dayjs(calDate));
      } else {
        // If it's single date in range picker, sync Calendar to that date
        setSelectedDate(dayjs(sDate));
      }
    }
    // If Source is 'single' (Calendar View), update List State
    else if (source === "single") {
      // Sync List View Range to the single date
      setSelectedDates([dayjs(sDate), dayjs(sDate)]);
    }

    try {
      // 4. Parallel Fetches
      const activeBranch = branchFilter !== "all" ? branchFilter : undefined;

      // Fetch List Data (Range)
      const listPromise = axiosInstance.post(`getAppointmentsByDoctorAndDate`, {
        startDate: sDate,
        endDate: eDate,
        doctorIds: doctorIds,
        ...(activeBranch && { branchId: activeBranch }),
      });

      // Fetch Calendar Data (Single Date / Today)
      const calPromise = (sDate === calDate && eDate === calDate)
        ? null // Will reuse list result
        : axiosInstance.post(`getAppointmentsByDoctorAndDate`, {
          startDate: calDate,
          endDate: calDate,
          doctorIds: doctorIds,
          ...(activeBranch && { branchId: activeBranch }),
        });

      // Execute Promises
      const [listRes, calRes] = await Promise.all([
        listPromise,
        calPromise ? calPromise : Promise.resolve(null)
      ]);

      // 5. Process List Data (Flatten & Set)
      if (listRes?.data?.success && listRes.data.data) {
        const data = listRes.data.data;
        let flatList = [];

        if (Array.isArray(data) && data.length > 0) {
          // Check if data is already flat (has appointmentDate directly)
          if (data[0].appointmentDate) {
            // Data is already flat - use directly
            flatList = data;
          } else if (data[0].appointments && Array.isArray(data[0].appointments)) {
            // Data is grouped - flatten it
            data.forEach((doctor) => {
              if (doctor.appointments && Array.isArray(doctor.appointments)) {
                doctor.appointments.forEach((appt) => {
                  flatList.push({
                    ...appt,
                    displayName: doctor.displayName,
                    doctorName: doctor.displayName,
                    doctorId: doctor.id
                  });
                });
              }
            });
          }
        }

        setAppointmentdata12(flatList);
        setDuplicateArray(flatList);
        setAppointmentdata(data);
      } else {
        setAppointmentdata12([]);
        setDuplicateArray([]);
        setAppointmentdata([]);
      }

      // 6. Process Calendar Data (Grouped & Set)
      const rawCalData = calRes
        ? (calRes.data?.success ? calRes.data.data : [])
        : (listRes?.data?.success ? listRes.data.data : []);

      // Transform flat data to grouped format for Calendar View
      let groupedCalData = [];
      if (Array.isArray(rawCalData) && rawCalData.length > 0) {
        // Check if data is flat (has appointmentDate)
        if (rawCalData[0].appointmentDate) {
          // Group by doctor
          const doctorMap = new Map();
          rawCalData.forEach((appt) => {
            const docId = appt.doctorId;
            if (!doctorMap.has(docId)) {
              doctorMap.set(docId, {
                id: docId,
                displayName: appt.displayName,
                appointments: []
              });
            }
            doctorMap.get(docId).appointments.push(appt);
          });
          groupedCalData = Array.from(doctorMap.values());
        } else {
          // Already grouped
          groupedCalData = rawCalData;
        }
      }

      // Ensure every selected doctor has a column even with 0 appointments
      const activeDoctorsList = (doctorsList && doctorsList.length > 0) ? doctorsList : doctors;
      if (doctorIds && doctorIds.length > 0 && activeDoctorsList.length > 0) {
        const docIdStrings = doctorIds.map(String);
        const existingIds = new Set(groupedCalData.map(d => String(d.id)));
        const missing = activeDoctorsList.filter(
          d => docIdStrings.includes(String(d.id)) && !existingIds.has(String(d.id))
        );
        if (missing.length > 0) {
          groupedCalData = [
            ...groupedCalData,
            ...missing.map(d => ({
              id: d.id,
              displayName: d.displayName ||
                `${d.prefix || ''} ${d.fullName || ''} ${d.shortName || ''}`.trim(),
              appointments: []
            }))
          ];
        }
      }
      setAppointmentPatient(groupedCalData);

      // Fetch which appointments have been Called / Arrived for this date (card view highlight)
      fetchStatusIds(calDate);

    } catch (error) {
      console.error("Sync Error:", error);
      Swal.fire("Error", "Failed to synchronize appointment data", "error");
    }
  };

  const applyUnifiedFilter = async () => {
    // ✅ FIX: Get FRESH data from localStorage, not stale state
    const userid11 = JSON.parse(localStorage.getItem("userarray"));

    // Priority: localStorage > state (because localStorage is source of truth)
    const freshIdsFromStorage = userid11?.data || [];
    const idsToUse = freshIdsFromStorage.length > 0 ? freshIdsFromStorage : arrayuser;

    if (!idsToUse || idsToUse.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "No Doctor Selected",
        text: "Please select at least one doctor",
      });
      return;
    }

    // Check if "Select All" is active
    const allDoctorIds = doctors.map((doc) => String(doc.id));
    const isSelectAll = idsToUse.length === allDoctorIds.length;

    // Determine Dates based on Active View (showdata)
    let sDate, eDate, source;

    if (showdata) {
      // List View Active -> Use Range Picker
      if (selectedDates && selectedDates.length > 0) {
        sDate = selectedDates[0].format("YYYY-MM-DD");
        eDate = selectedDates[1] ? selectedDates[1].format("YYYY-MM-DD") : sDate;
        source = 'range';
      } else {
        const today = dayjs().format("YYYY-MM-DD");
        sDate = today;
        eDate = today;
        source = 'single';
      }
    } else {
      // Calendar View Active -> Use Single Picker
      if (selectedDate) {
        sDate = selectedDate.format("YYYY-MM-DD");
        eDate = sDate;
        source = 'single';
      } else {
        const today = dayjs().format("YYYY-MM-DD");
        sDate = today;
        eDate = today;
        source = 'single';
      }
    }

    // ✅ FIX: Pass fresh IDs to sync function
    await syncFiltersAndFetch(sDate, eDate, idsToUse, source);

    // Save & Close
    await savedoctor(idsToUse);
    handleclose111();
    handlelcicktoope1111nFALSE();
  };
  const userid = JSON.parse(localStorage.getItem("userMedical"));
  const savedoctor = async (ids) => {
    const doctorsToSave = ids || arrayuser;
    if (!doctorsToSave || doctorsToSave.length === 0) {
      console.warn("No doctors selected. API not called.");
      return;
    }
    const obj = {
      doctor_id: userid?.data?.id,
      filter_doctor_ids: doctorsToSave,
    };
    try {
      const response = await axiosInstance.post(`saveFilterDoctors`, obj);
      if (response.status === 200) {
      } else {
        console.warn("Failed to save doctors");
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };


  // ✅ NEW: Fetch data when Select All is clicked
  const fetchAllDoctorsData = async (allDoctorIds) => {
    try {
      // Determine current view's dates
      let sDate, eDate, source;

      if (showdata) {
        // List View
        if (selectedDates && selectedDates.length > 0) {
          sDate = selectedDates[0].format("YYYY-MM-DD");
          eDate = selectedDates[1] ? selectedDates[1].format("YYYY-MM-DD") : sDate;
        } else {
          const today = dayjs().format("YYYY-MM-DD");
          sDate = today;
          eDate = today;
        }
        source = 'range';
      } else {
        // Calendar View
        if (selectedDate) {
          sDate = selectedDate.format("YYYY-MM-DD");
        } else {
          sDate = dayjs().format("YYYY-MM-DD");
        }
        eDate = sDate;
        source = 'single';
      }

      // Fetch with ALL doctors
      await syncFiltersAndFetch(sDate, eDate, allDoctorIds, source);

      // Save to DB
      await savedoctor();

    } catch (error) {
      console.error("Error fetching all doctors data:", error);
    }
  };

  // ✅ NEW: Clear all filters
  const clearAllFilters = async () => {
    // Clear all data
    setAppointmentdata12([]);
    setAppointmentPatient([]);
    setAppointmentdata([]);
    setDuplicateArray([]);

    // Optionally fetch all appointments without filter
    // await getdata(); // Uncomment if you want to show all

    Swal.fire({
      icon: "info",
      title: "Filters Cleared",
      text: "Showing no data. Please select doctors to filter.",
    });
  };

  // ✅ NEW: Trigger filter for List View modal
  const triggerFilterWithAllDoctors = async (allDoctorIds) => {
    // Similar to fetchAllDoctorsData but for List View modal context
    let sDate, eDate, source;

    if (selectedDates && selectedDates.length > 0) {
      sDate = selectedDates[0].format("YYYY-MM-DD");
      eDate = selectedDates[1] ? selectedDates[1].format("YYYY-MM-DD") : sDate;
      source = 'range';
    } else {
      const today = dayjs().format("YYYY-MM-DD");
      sDate = today;
      eDate = today;
      source = 'single';
    }

    await syncFiltersAndFetch(sDate, eDate, allDoctorIds, source);
  };


  const BookingConfirm = async () => {
    const start = new Date(`2020-01-01T${dataConfirm.startTime}`);
    const end = new Date(`2020-01-01T${dataConfirm.endTime}`);
    const startHour = start.getHours();
    const endHour = end.getHours();
    if (startHour < 0 || startHour > 23) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Start Time",
        text: "Start time must be between 12:00 AM and 11:59 PM",
      });
      return;
    }
    if (endHour < 0 || endHour > 23) {
      Swal.fire({
        icon: "warning",
        title: "Invalid End Time",
        text: "End time must be between 12:00 AM and 11:59 PM",
      });
      return;
    }
    if (end <= start) {
      Swal.fire({
        icon: "error",
        title: "Invalid Time Range",
        text: "End time must be after start time.",
      });
      return;
    }
    const diffInMs = end - start;
    const diffInHours = diffInMs / (1000 * 60 * 60);
    const diffInMinutes = diffInMs / (1000 * 60);
    if (diffInMinutes < 5) {
      Swal.fire({
        icon: "warning",
        title: "Short Duration",
        text: "Appointment must be at least 5 minutes long.",
      });
      return;
    }
    if (diffInHours > 2) {
      Swal.fire({
        icon: "warning",
        title: "Long Duration",
        text: "Appointment can't be more than 2 hours long.",
      });
      return;
    }
    const datapost = {
      doctorId: dataConfirm.doctorId,
      startTime: dataConfirm.startTime,
      endTime: dataConfirm.endTime,
      date: dataConfirm.date,
    };
    try {
      const response = await axiosInstance.post(
        `bookingAppointment/${eid}`,
        datapost
      );
      if (response.data.success === true) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "Appointment added successfully.",
        });
        handleclose22();
        getCalendarData();
        handleclose();
        waitingAppointmentList1();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed!",
          text: response.data.message || "Unable to add appointment.",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Server Error",
        text:
          error.response?.data?.message ||
          "Something went wrong. Please try again.",
      });
    }
  };

  const handlechangeDropdownData = (e, id) => {
    const { value } = e.target;
    uctioncall(value, id);
  };
  const uctioncall = async (value, id) => {

    // ✅ FIX: Always get FRESH doctor IDs from localStorage
    const userid11 = JSON.parse(localStorage.getItem("userarray"));
    const freshDoctorIds = userid11?.data || [];

    const datapost = { status: value };

    try {
      const response = await axiosInstance.post(
        `changeAppointmentStatus/${id}`,
        datapost
      );

      if (response.data.success === true) {
        // ✅ FIX: Use freshDoctorIds instead of arrayuser
        if (freshDoctorIds && freshDoctorIds.length > 0) {

          let sDate, eDate, source;

          if (showdata) {
            // List View
            if (selectedDates && selectedDates.length > 0) {
              sDate = selectedDates[0].format("YYYY-MM-DD");
              eDate = selectedDates[1] ? selectedDates[1].format("YYYY-MM-DD") : sDate;
            } else {
              const today = dayjs().format("YYYY-MM-DD");
              sDate = today;
              eDate = today;
            }
            source = 'range';
          } else {
            // Calendar View
            if (selectedDate) {
              sDate = selectedDate.format("YYYY-MM-DD");
            } else {
              sDate = dayjs().format("YYYY-MM-DD");
            }
            eDate = sDate;
            source = 'single';
          }

          // ✅ Use fresh IDs from localStorage
          await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);

        } else {
          // No doctors selected - show all
          await getdata();
        }

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response.data.message,
        });
      }
    } catch (error) {
      console.error("Something went wrong", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Failed to update status",
      });
    }
  };

  const sendAppointmentWhatsApp = async (appointmentId) => {
    try {
      const response = await axiosInstance.post(
        `sendAppointmentWhatsApp/${appointmentId}`
      );

      if (response.data.success) {
        const phone = response.data.phone.replace("+", "");
        const text = encodeURIComponent(response.data.message);
        window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${text}`, "_blank");
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to prepare WhatsApp message.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error sending WhatsApp:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "An error occurred while preparing WhatsApp message.",
        "error"
      );
    }
  };

  const sendAppointmentSMS = async (appointmentId) => {
    try {
      Swal.fire({
        title: "Sending SMS...",
        text: "Please wait",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axiosInstance.post(
        `sendAppointmentSMS/${appointmentId}`
      );

      if (response.data.success) {
        Swal.fire("Success", "SMS sent successfully!", "success");
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to send SMS.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error sending SMS:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message || "An error occurred while sending SMS.",
        "error"
      );
    }
  };

  const handledelet = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axiosInstance.delete(`deleteAppointments/${id}`);
        Swal.fire("Deleted!", "appointment has been deleted.", "success");

        waitingAppointmentList1();

        // ✅ FIX: Get fresh doctor IDs from localStorage
        const userid11 = JSON.parse(localStorage.getItem("userarray"));
        const freshDoctorIds = userid11?.data || [];

        if (freshDoctorIds && freshDoctorIds.length > 0) {
          // Refresh with current filters
          let sDate, eDate, source;

          if (showdata) {
            if (selectedDates?.length > 0) {
              sDate = selectedDates[0].format("YYYY-MM-DD");
              eDate = selectedDates[1]?.format("YYYY-MM-DD") || sDate;
            } else {
              sDate = dayjs().format("YYYY-MM-DD");
              eDate = sDate;
            }
            source = 'range';
          } else {
            sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
            eDate = sDate;
            source = 'single';
          }

          await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);
        } else {
          await getdata();
        }

      } catch (error) {
        Swal.fire("Error!", "Something went wrong while deleting.", "error");
      }
    }
  };
  const handleclickchange = () => {
    setShowdata(false);
    setViewMode("calendar");
  };
  const handleclickchange11 = () => {
    setShowdata(true);
    setViewMode("list");
  };
  const handleclickchangeCard = () => {
    setShowdata(false);
    setViewMode("card");
  };
  const hours = Array.from({ length: 12 }, (_, i) => i + 12); // 7 AM to 6 PM
  const convertToHourFromTimeString = (timeStr) => {
    if (!timeStr) return 0;
    const [hour, minute, second] = timeStr.split(":").map(Number);
    return hour;
  };
  const getUniqueDoctors = (appointments) => {
    const doctorSet = new Set();
    appointments.forEach((app) =>
      doctorSet.add(app.displayName?.trim().toLowerCase())
    );
    return Array.from(doctorSet);
  };
  const getCalendarData = async () => {
    try {
      const response = await axiosInstance.get(`getConfirmedAppointments`);
      if (response.data.success === true) {
        setAppointmentPatient(response.data.data);
        fetchStatusIds();
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error?.response?.data?.message || error.message);
    }
  };
  useEffect(() => {
    getCalendarData();
  }, []);
  const [clinicWorkingHours, setClinicWorkingHours] = useState({ start_time: "07:00:00", end_time: "20:00:00" });
  useEffect(() => {
    axiosInstance.get("getClinicWorkingHours")
      .then(res => {
        if (res.data?.success && res.data.data) setClinicWorkingHours(res.data.data);
      })
      .catch(() => {});
  }, []);
  const doctorNames = getUniqueDoctors(appointmentpatiemt);
  const [showCalendarModal, setShowCalendarModal] = useState(false);
  const enrichAppointmentData = (basicData) => {
    if (!basicData) return basicData;
    // If we already have the rich data, return it
    if (basicData.profileImage && basicData.age) return basicData;

    // Search in appointmentpatiemt (Calendar Data)
    if (appointmentpatiemt && appointmentpatiemt.length > 0) {
      for (const doctor of appointmentpatiemt) {
        if (doctor.appointments && Array.isArray(doctor.appointments)) {
          const found = doctor.appointments.find((app) => app.id === basicData.id);
          if (found) {
            return { ...basicData, ...found };
          }
        }
      }
    }
    return basicData;
  };

  // Hover preview (quick peek shown on mouse-over of a calendar appointment block,
  // mirrors the full click-through modal without stealing focus/clicks).
  const [hoverAppointment, setHoverAppointment] = useState(null);
  const [hoverPosition, setHoverPosition] = useState({ top: 0, left: 0 });
  const [hoverWaitingRecord, setHoverWaitingRecord] = useState(null);
  const [hoverNoShowRisk, setHoverNoShowRisk] = useState(null);
  const hoverTimeoutRef = useRef(null);

  const handleApptHoverEnter = (e, app) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const tooltipWidth = 300;
    const spaceOnRight = window.innerWidth - rect.right;
    const left = spaceOnRight >= tooltipWidth + 16
      ? rect.right + 10
      : Math.max(8, rect.left - tooltipWidth - 10);
    const top = Math.min(rect.top, window.innerHeight - 420);

    const richApp = enrichAppointmentData(app);
    setHoverPosition({ top: Math.max(8, top), left });
    setHoverAppointment(richApp);
    setHoverWaitingRecord(null);
    setHoverNoShowRisk(null);

    if (hoverTimeoutRef.current) clearTimeout(hoverTimeoutRef.current);
    hoverTimeoutRef.current = setTimeout(() => {
      axiosInstance.get(`getWaitingRecord/${app.id}`)
        .then(res => setHoverWaitingRecord(res.data?.data || null))
        .catch(() => {});

      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      const isRiskEligible =
        (richApp.status === "Booked" || richApp.status === "Confirmed") &&
        richApp.appointmentDate &&
        new Date(richApp.appointmentDate).setHours(0, 0, 0, 0) >= todayStart.getTime();
      if (isRiskEligible) {
        axiosInstance
          .post(`getAppointmentNoShowRisk`, { appointmentIds: [app.id] })
          .then((res) => {
            if (res.data.success) setHoverNoShowRisk(res.data.data[app.id] || null);
          })
          .catch(() => {});
      }
    }, 350);
  };

  const handleApptHoverLeave = () => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setHoverAppointment(null);
    setHoverWaitingRecord(null);
    setHoverNoShowRisk(null);
  };

  // Click on empty calendar-grid space (no appointment there) -> open New Appointment
  // prefilled with that doctor + the clicked time, for fast booking.
  const handleEmptySlotClick = (doctor, hour, minute) => {
    if (!doctor?.id) return;
    const dateStr = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
    const startTime = `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
    setNewAppointmentPrefill({ doctorId: doctor.id, appointmentDate: dateStr, startTime });
    setShowNewAppointmentModal(true);
  };

  const Openmodalfunction = (app) => {
    const richApp = enrichAppointmentData(app);
    setShowCalendarModal(true);
    setDatamodalappointment(richApp);
    setWaitingRecord(null);
    axiosInstance.get(`getWaitingRecord/${app.id}`)
      .then(res => setWaitingRecord(res.data?.data || null))
      .catch(() => {});

    setModalNoShowRisk(null);
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const isRiskEligible =
      (richApp.status === "Booked" || richApp.status === "Confirmed") &&
      richApp.appointmentDate &&
      new Date(richApp.appointmentDate).setHours(0, 0, 0, 0) >= todayStart.getTime();
    if (isRiskEligible) {
      axiosInstance
        .post(`getAppointmentNoShowRisk`, { appointmentIds: [app.id] })
        .then((res) => {
          if (res.data.success) setModalNoShowRisk(res.data.data[app.id] || null);
        })
        .catch((error) => console.error("Error fetching no-show risk:", error));
    }
  };

  const handleArrived = async () => {
    try {
      await axiosInstance.post(`logArrival/${datamodalappointment.id}`);
      const res = await axiosInstance.get(`getWaitingRecord/${datamodalappointment.id}`);
      setWaitingRecord(res.data?.data || null);
      setArrivedIds(prev => new Set([...prev, datamodalappointment.id]));
      setArrivalTimes(prev => ({ ...prev, [datamodalappointment.id]: res.data?.data?.arrival_time || new Date().toISOString() }));
    } catch (e) {
      console.error("Failed to log arrival", e);
    }
  };

  const handleCall = async () => {
    try {
      await axiosInstance.post(`logCall/${datamodalappointment.id}`);
      const res = await axiosInstance.get(`getWaitingRecord/${datamodalappointment.id}`);
      setWaitingRecord(res.data?.data || null);
      setCalledIds(prev => new Set([...prev, datamodalappointment.id]));
      setCallTimes(prev => ({ ...prev, [datamodalappointment.id]: res.data?.data?.call_time || new Date().toISOString() }));
    } catch (e) {
      console.error("Failed to log call", e);
    }
  };
  // Call a patient directly from the Waiting Room list (no detail modal open yet).
  // Once called, the timer stops and the patient drops out of the Waiting Room list.
  const handleCallFromWaitingRoom = async (appointmentId) => {
    try {
      await axiosInstance.post(`logCall/${appointmentId}`);
      setCalledIds(prev => new Set([...prev, appointmentId]));
      setCallTimes(prev => ({ ...prev, [appointmentId]: new Date().toISOString() }));
      setWaitingRoomList(prev => prev.filter(a => a.id !== appointmentId));
    } catch (e) {
      console.error("Failed to log call", e);
    }
  };
  const closeCalendarModal = () => {
    setShowCalendarModal(false);
  };
  const filteredData = waitngData?.filter((item) =>
    item?.patientName?.toLowerCase().includes(searchText)
  );
  const timeSlots = Array.from({ length: 48 }, (_, index) => {
    const hour = Math.floor(index / 2);
    const minute = index % 2 === 0 ? "00" : "30";
    return `${hour.toString().padStart(2, "0")}:${minute}`;
  });
  const getRowIndex = (time) => {
    if (!time) return 0;
    const [hourStr, minuteStr] = time.split(":");
    const hour = parseInt(hourStr);
    const minute = parseInt(minuteStr);
    return hour * 2 + (minute >= 30 ? 1 : 0);
  };
  const handleMultiDateFilter123 = async () => {
    if (!selectedDates || selectedDates.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Warning!",
        text: "Please select Date Range",
      });
      return;
    }
    const sDate = selectedDates[0].format("YYYY-MM-DD");
    const eDate = selectedDates[1] ? selectedDates[1].format("YYYY-MM-DD") : sDate;

    // Call Unified Sync (Source: Range)
    await syncFiltersAndFetch(sDate, eDate, arrayuser, 'range');
  };

  const handleMultiDateFiltersingledate = async () => {
    if (!selectedDate) {
      Swal.fire({
        icon: "warning",
        title: "Warning!",
        text: "Please select Date",
      });
      return;
    }
    const sDate = selectedDate.format("YYYY-MM-DD");

    // Call Unified Sync (Source: Single)
    await syncFiltersAndFetch(sDate, sDate, arrayuser, 'single');
  };

  const handleDateNav = async (newDate) => {
    setSelectedDate(newDate);
    const sDate = newDate.format("YYYY-MM-DD");
    const userid11 = JSON.parse(localStorage.getItem("userarray"));
    const freshIds = userid11?.data || [];
    const idsToUse = freshIds.length > 0 ? freshIds : arrayuser;
    await syncFiltersAndFetch(sDate, sDate, idsToUse, 'single');
  };

  const handleclickcancleapoointment = async (item) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to cancel this appointment?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, cancel it!",
      cancelButtonText: "No, keep it",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.put(
            `cancelAppointmentStatus/${item.id}`
          );
          if (response.data.success === true) {
            setShowCalendarModal(false);

            // Refresh data while preserving current filters
            const userid11 = JSON.parse(localStorage.getItem("userarray"));
            const freshDoctorIds = userid11?.data || arrayuser;

            if (freshDoctorIds.length > 0) {
              let sDate, eDate, source;
              if (showdata) {
                // List View - use date range
                if (selectedDates && selectedDates.length > 0) {
                  sDate = selectedDates[0].format("YYYY-MM-DD");
                  eDate = selectedDates[1]?.format("YYYY-MM-DD") || sDate;
                } else {
                  sDate = dayjs().format("YYYY-MM-DD");
                  eDate = sDate;
                }
                source = 'range';
              } else {
                // Calendar View - use single date
                sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
                eDate = sDate;
                source = 'single';
              }
              await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);
            } else {
              await getdata();
            }
            Swal.fire(
              "Success",
              "Appointment cancelled successfully",
              "success"
            );
          } else {
            console.error("Cancellation failed:", response.data);
            Swal.fire(
              "Error",
              response.data.message || "Cancellation failed",
              "error"
            );
          }
        } catch (error) {
          console.error("Something went wrong:", error);
          Swal.fire("Error", "Something went wrong while cancelling", "error");
        }
      } else {
        console.warn("User cancelled the operation.");
      }
    });
  };
  const handlelcicktoopen = () => {
    setShowModalDoctor(true);
  };
  const handlelcicktoope1111n = () => {
    setShowModalDoctor23(true);
  };
  const handlelcicktoope1111nFALSE = () => {
    setShowModalDoctor23(false);
  };
  const handleclose111 = () => {
    setShowModalDoctor(false);
  };
  const fetchDoctors = async () => {
    try {
      const response = await axiosInstance.get(`getActiveDoctors`);
      if (response.data.success) {
        setDoctors(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching doctors:", error);
    }
  };
  const handleclick11111111 = async (item) => {
    let richItem = enrichAppointmentData(item);

    // If still missing details, try fetching by patientId
    if (!richItem.profileImage || !richItem.age) {
      const pId = richItem.patientId || richItem.patient_id;
      if (pId) {
        try {
          const response = await axiosInstance.get(`getPatientById/${pId}`);
          if (response.data && (response.data.data || response.data.success)) { // handle various response structures
            const pData = response.data.data || response.data;

            // Calculate age if missing but DOB is present
            let calculatedAge = pData.age;
            if (!calculatedAge && pData.dateOfBirth) {
              const diff = Date.now() - new Date(pData.dateOfBirth).getTime();
              const ageDate = new Date(diff);
              calculatedAge = Math.abs(ageDate.getUTCFullYear() - 1970);
            }

            richItem = {
              ...richItem,
              ...pData,
              profileImage: pData.profileImage || richItem.profileImage,
              age: calculatedAge || richItem.age,
            };
          }
        } catch (error) {
          console.error("Error fetching patient details:", error);
        }
      }
    }

    setAppointviewdata(richItem);
    setVidewmodapopen(true);
  };
  const closeCalendarModal1111 = () => {
    setVidewmodapopen(false);
  };
  const handleupdateconfirm = async (item) => {
    try {
      const response = await axiosInstance.post(
        `changeAppointmentStatus/${item.id}`,
        { status: "Confirmed" }
      );

      if (response.data.success === true) {

        // ✅ FIX: Get fresh doctor IDs from localStorage
        const userid11 = JSON.parse(localStorage.getItem("userarray"));
        const freshDoctorIds = userid11?.data || [];

        if (freshDoctorIds && freshDoctorIds.length > 0) {
          let sDate, eDate, source;

          if (showdata) {
            if (selectedDates && selectedDates.length > 0) {
              sDate = selectedDates[0].format("YYYY-MM-DD");
              eDate = selectedDates[1]?.format("YYYY-MM-DD") || sDate;
            } else {
              const today = dayjs().format("YYYY-MM-DD");
              sDate = today;
              eDate = today;
            }
            source = 'range';
          } else {
            if (selectedDate) {
              sDate = selectedDate.format("YYYY-MM-DD");
            } else {
              sDate = dayjs().format("YYYY-MM-DD");
            }
            eDate = sDate;
            source = 'single';
          }

          await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);
        }

        closeCalendarModal();
        Swal.fire("success", "Appointment Confirmed", "success");
      }
    } catch (error) {
      console.error("Error:", error.message);
    }
  };
  const handledopencllick = (item) => {
    closeCalendarModal();
    setEditModalTimeMode("slots");
    setEditModalBookedSlots([]);
    setEditModalOriginalStatus(item?.status || "");
    setAppointmentdata1({
      ...item,
      doctorId: item?.doctorId ? String(item.doctorId) : "",
      appointmentDate: item?.appointmentDate
        ? dayjs(item.appointmentDate).format("YYYY-MM-DD")
        : "",
      startTime: item?.startTime ? item.startTime.slice(0, 5) : "",
      endTime: item?.endTime ? item.endTime.slice(0, 5) : "",
    });
    setShowModaledit(true);
  };
  const handleclose111dff = () => {
    setShowModaledit(false);
    setAppointmentdata1({});
    setEditModalBookedSlots([]);
  };
  const handleChange23 = (e) => {
    const { name, value } = e.target;
    setAppointmentdata1((prev) => ({ ...prev, [name]: value }));
  };
  const handleEditSlotClick = (slot) => {
    const isBooked = editModalBookedSlots.some(({ startTime, endTime }) => {
      if (!startTime || !endTime) return false;
      const slotMin = toMins(slot);
      const slotEnd = slotMin + 10;
      const bStart = toMins(startTime.substring(0, 5));
      const bEnd = toMins(endTime.substring(0, 5));
      return slotMin < bEnd && slotEnd > bStart;
    });
    const isPast =
      appointmentdata1?.appointmentDate === dayjs().format("YYYY-MM-DD") &&
      toMins(slot) < dayjs().hour() * 60 + dayjs().minute();
    if (isBooked || isPast) return;
    const startMin = toMins(slot);
    const endMin = Math.min(startMin + 30, 23 * 60 + 50);
    setAppointmentdata1((prev) => ({ ...prev, startTime: slot, endTime: fromMins(endMin) }));
  };
  const updateAppointment = async () => {
    try {
      const { appointmentDate, startTime, endTime, reason, status, id, doctorId } = appointmentdata1;

      // Validation
      if (!doctorId) {
        return Swal.fire({
          icon: "warning",
          title: "Missing Field",
          text: "Please select a doctor.",
        });
      }

      if (!appointmentDate) {
        return Swal.fire({
          icon: "warning",
          title: "Missing Field",
          text: "Please select an appointment date.",
        });
      }

      if (!startTime || !endTime) {
        return Swal.fire({
          icon: "warning",
          title: "Missing Fields",
          text: "Please select both start and end times.",
        });
      }

      // ✅ FIX: Use dayjs for consistent date formatting
      const formattedDate = dayjs(appointmentDate).format("YYYY-MM-DD");

      // ✅ FIX: Ensure times are in HH:MM format
      const formatTime = (time) => {
        if (!time) return "";
        if (/^\d{2}:\d{2}$/.test(time)) return time;
        if (time.includes(":")) {
          return time.split(":").slice(0, 2).join(":");
        }
        return time;
      };

      const formattedStartTime = formatTime(startTime);
      const formattedEndTime = formatTime(endTime);

      // Time validation
      const [startHour, startMinute] = formattedStartTime.split(":").map(Number);
      const [endHour, endMinute] = formattedEndTime.split(":").map(Number);
      const startTotal = startHour * 60 + startMinute;
      const endTotal = endHour * 60 + endMinute;

      if (endTotal <= startTotal) {
        return Swal.fire({
          icon: "warning",
          title: "Invalid Time Selection",
          text: "End time must be later than start time.",
        });
      }

      if (endTotal - startTotal < 5) {
        return Swal.fire({
          icon: "warning",
          title: "Invalid Time Range",
          text: "End time must be at least 5 minutes after start time.",
        });
      }

      if (!reason || reason.trim() === "") {
        return Swal.fire({
          icon: "warning",
          title: "Missing Reason",
          text: "Please provide a reason for the appointment.",
        });
      }

      const obj = {
        appointmentDate: formattedDate,        // ✅ Fixed: YYYY-MM-DD
        startTime: formattedStartTime,         // ✅ Fixed: HH:MM
        endTime: formattedEndTime,             // ✅ Fixed: HH:MM
        reason: reason.trim(),
        doctorId,
      };

      if (!id) {
        return Swal.fire({
          icon: "error",
          title: "Invalid Appointment",
          text: "Missing appointment ID. Please refresh and try again.",
        });
      }

      const response = await axiosInstance.put(`editAppointment/${id}`, obj);

      // Status (Waiting / Emergency / regular-Booked) lives on a separate endpoint
      // from date/time/reason/doctor. Only touch it if Type was actually changed,
      // so editing date/time doesn't silently revert e.g. a Confirmed/Completed
      // appointment back to "Booked".
      const resolvedStatus = status || "Booked";
      if (resolvedStatus !== (editModalOriginalStatus || "Booked")) {
        try {
          await axiosInstance.post(`changeAppointmentStatus/${id}`, { status: resolvedStatus });
        } catch (statusErr) {
          console.error("Failed to update appointment status:", statusErr);
        }
      }

      if (response?.data?.success === true) {
        // ✅ FIX: Refresh with current filters using localStorage
        const userid11 = JSON.parse(localStorage.getItem("userarray"));
        const freshDoctorIds = userid11?.data || [];

        if (freshDoctorIds && freshDoctorIds.length > 0) {
          let sDate, eDate, source;

          if (showdata) {
            // List View
            if (selectedDates?.length > 0) {
              sDate = selectedDates[0].format("YYYY-MM-DD");
              eDate = selectedDates[1]?.format("YYYY-MM-DD") || sDate;
            } else {
              sDate = dayjs().format("YYYY-MM-DD");
              eDate = sDate;
            }
            source = 'range';
          } else {
            // Calendar View
            sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
            eDate = sDate;
            source = 'single';
          }

          await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);
        } else {
          await getdata();
        }

        getCalendarData?.();
        setAppointmentdata1({});
        handleclose111dff?.();

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Appointment updated successfully!",
        });

      } else {
        Swal.fire({
          icon: "error",
          title: "Update Failed",
          text: response?.data?.message || "Server returned an unknown error.",
        });
      }

    } catch (error) {
      console.error("Update appointment error:", error);
      // ... existing error handling ...
    }
  };
  const filteredPatients = appointmentdata12.filter((item) => {
    if (statusFilter === "completed" && item.status?.toLowerCase() !== "completed") return false;
    if (statusFilter === "pending" && item.status?.toLowerCase() === "completed") return false;
    const isMultiBranch = allBranchSettings && allBranchSettings.length > 1;
    if (isMultiBranch && branchFilter !== "all" && String(item.branch_id) !== branchFilter) return false;
    return (
      `${item.doctorName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.patientName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.reason?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.displayName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.duration?.toString().includes(searchTerm) ||
      item.mobileNumber?.toString().includes(searchTerm) ||
      (item.appointmentDate &&
        new Date(item.appointmentDate)
          .toLocaleDateString("en-GB")
          .includes(searchTerm))
    );
  });
  const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentPatients = filteredPatients.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const riskEligibleIds = currentPatients
      .filter(
        (item) =>
          (item.status === "Booked" || item.status === "Confirmed") &&
          item.appointmentDate &&
          new Date(item.appointmentDate).setHours(0, 0, 0, 0) >= todayStart.getTime()
      )
      .map((item) => item.id)
      .filter((id) => noShowRiskById[id] === undefined);

    if (riskEligibleIds.length === 0) return;

    axiosInstance
      .post(`getAppointmentNoShowRisk`, { appointmentIds: riskEligibleIds })
      .then((response) => {
        if (response.data.success) {
          setNoShowRiskById((prev) => ({ ...prev, ...response.data.data }));
        }
      })
      .catch((error) => console.error("Error fetching no-show risk:", error));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPatients.map((item) => item.id).join(",")]);
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleclickddappointment = async (handleclickddappointment) => {
    try {
      const response = await axiosInstance.put(
        `cancelAppointmentStatus/${handleclickddappointment.id}`
      );
      if (response.data.success === true) {
        const userid11 = JSON.parse(localStorage.getItem("userarray"));
        const freshDoctorIds = userid11?.data || [];
        if (freshDoctorIds.length > 0) {
          let sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
          let eDate = sDate;
          let source = 'single';
          if (showdata && selectedDates?.length > 0) {
            sDate = selectedDates[0].format("YYYY-MM-DD");
            eDate = selectedDates[1]?.format("YYYY-MM-DD") || sDate;
            source = 'range';
          }
          await syncFiltersAndFetch(sDate, eDate, freshDoctorIds, source);
        } else {
          await getdata();
        }
        getCalendarData();
        setShowModaledit(false);
        Swal.fire("Success", "Appointment cancelled successfully", "success");
      } else {
        console.warn("Cancellation failed:", response.data);
        Swal.fire(
          "Error",
          response.data.message || "Cancellation failed",
          "error"
        );
      }
    } catch (error) {
      console.error("something went wrong");
    }
  };
  const handleSendEmail = async (appointment) => {
    if (!appointment || !appointment.id) {
      Swal.fire("Error", "Appointment data not found", "error");
      return;
    }
    try {
      Swal.fire({
        title: "Sending Email...",
        text: "Please wait while we send the email notification",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const response = await axiosInstance.post(
        `sendAppointmentEmail/${appointment.id}`
      );
      if (response.data.success === true) {
        Swal.fire(
          "Success!",
          "Email notification sent successfully",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to send email",
          "error"
        );
      }
    } catch (error) {
      console.error("Email sending error:", error);
      Swal.fire(
        "Error",
        error.response?.data?.message ||
        "Something went wrong while sending email",
        "error"
      );
    }
  };
  const statusColors = {
    "No-show": { backgroundColor: "#f8d7da", color: "#721c24" },
    Completed: { backgroundColor: "#d4edda", color: "#155724" },
    Cancelled: { backgroundColor: "rgb(255 3 0 / 13%)", color: "#1e9690ff" },
    Emergency: { backgroundColor: "rgb(255 3 0 / 13%)", color: "#ff0000" },
    Booked: { backgroundColor: "#7da0f92b", color: "#4680ff" },
    Waiting: { backgroundColor: "#fff3cd", color: "#9c7705ff" },
    Confirmed: { backgroundColor: "#d1ecf1", color: "#0c5460" },
  };
  const riskBadgeConfig = {
    low: { backgroundColor: "#f1f3f5", color: "#5B6B79", label: "Low" },
    medium: { backgroundColor: "#fff3cd", color: "#9c7705", label: "Medium" },
    high: { backgroundColor: "#f8d7da", color: "#a01c2b", label: "High" },
  };
  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="col-12">
          {/* ── Page Title ── */}
          {/*
          <div style={{ background: '#fff', borderRadius: 12, border: '1px solid #e8ecf0', padding: '14px 20px', display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <button
              onClick={() => navigate(-1)}
              title="Back"
              style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, marginRight: 4, flexShrink: 0 }}
              onMouseEnter={e => { e.currentTarget.style.background = '#4680ff22'; e.currentTarget.style.color = '#4680ff' }}
              onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79' }}
            ><i className="ti ti-arrow-left" /></button>
            <div style={{ width: 32, height: 32, borderRadius: 8, background: '#4680ff20', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <i className="ti ti-calendar-event" style={{ color: '#4680ff', fontSize: 17 }} />
            </div>
            <div>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>Appointments</div>
              <div style={{ fontSize: 11, color: '#5B6B79' }}>Manage and view all scheduled appointments</div>
            </div>
          </div>
          */}

          <div className="">
            <div style={{ background: '#fff', border: '1px solid #e8ecf0', borderRadius: 10, padding: '8px 12px' }}>

              {/* ── Toolbar Row ── */}
              <div className="calenderClock appt2-toolbar" style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>

                {/* Left: Action Buttons */}
                <div className="appt2-actions" style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                  <button
                    className="bgBtn"
                    style={{
                      padding: '5px 12px',
                      fontSize: 13,
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                      opacity: canAddAppointment ? 1 : 0.5,
                      cursor: canAddAppointment ? 'pointer' : 'not-allowed',
                    }}
                    disabled={!canAddAppointment}
                    title={canAddAppointment ? '' : "You don't have permission to add appointments"}
                    onClick={() => canAddAppointment && setShowNewAppointmentModal(true)}
                  >
                    <i className="ti ti-plus" style={{ fontSize: 14 }} />
                    New Appointment
                  </button>

                  <button
                    className="borderBtn position-relative"
                    style={{ padding: '5px 12px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 4 }}
                    onClick={handleclickmodal}
                  >
                    <i className="ti ti-door-enter" style={{ fontSize: 14 }} />
                    Walk-in
                    {waitngData?.length > 0 && (
                      <span style={{
                        position: 'absolute', top: -7, right: -7,
                        fontSize: 10, fontWeight: 700, lineHeight: 1,
                        minWidth: 18, height: 18, padding: '0 4px', borderRadius: 9,
                        background: '#dc3545', color: '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.25)', zIndex: 100,
                      }}>
                        {waitngData.length > 99 ? '99+' : waitngData.length}
                      </span>
                    )}
                  </button>

                  <button
                    className="borderBtn position-relative"
                    style={{ padding: '5px 12px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 4 }}
                    onClick={() => setWaitingRoomOpen(true)}
                  >
                    <i className="ti ti-hourglass" style={{ fontSize: 14 }} />
                    Waiting Room
                    {waitingRoomList.length > 0 && (
                      <span style={{
                        position: 'absolute', top: -7, right: -7,
                        fontSize: 10, fontWeight: 700, lineHeight: 1,
                        minWidth: 18, height: 18, padding: '0 4px', borderRadius: 9,
                        background: '#dc3545', color: '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.25)', zIndex: 100,
                      }}>
                        {waitingRoomList.length > 99 ? '99+' : waitingRoomList.length}
                      </span>
                    )}
                  </button>

                  <button
                    className="borderBtn position-relative"
                    style={{ padding: '5px 12px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 4 }}
                    onClick={handleOnlineBookingClick}
                  >
                    <i className="ti ti-world" style={{ fontSize: 14 }} />
                    Online Booking
                    {pendingOnlineCount > 0 && (
                      <span style={{
                        position: 'absolute', top: -7, right: -7,
                        fontSize: 10, fontWeight: 700, lineHeight: 1,
                        minWidth: 18, height: 18, padding: '0 4px', borderRadius: 9,
                        background: '#dc3545', color: '#fff',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        border: '2px solid #fff', boxShadow: '0 1px 4px rgba(0,0,0,0.25)', zIndex: 100,
                      }}>
                        {pendingOnlineCount > 99 ? '99+' : pendingOnlineCount}
                        <span className="visually-hidden">pending online appointments</span>
                      </span>
                    )}
                  </button>

                  <button
                    className="borderBtn"
                    style={{ padding: '5px 12px', fontSize: 13, display: 'flex', alignItems: 'center', gap: 4 }}
                    onClick={openSmsLog}
                  >
                    <i className="ti ti-message-report" style={{ fontSize: 14 }} />
                    SMS Log
                  </button>
                </div>

                {/* Center: Clock */}
                <div className="parentWatch appt2-clock">
                  <AnalogClock />
                </div>

                {/* Right: View controls + Date picker */}
                <div className="appt2-view-controls" style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>

                  {/* View mode toggle group */}
                  <div style={{ display: 'flex', alignItems: 'center', background: '#f5f7fa', border: '1px solid #e8ecf0', borderRadius: 8, padding: 2, gap: 1 }}>
                    {/* Filter toggle */}
                    <button
                      onClick={showdata ? handlelcicktoope1111n : handlelcicktoopen}
                      title="Filter / Date Range"
                      style={{ width: 30, height: 28, border: 'none', borderRadius: 6, background: showdata ? '#fff' : 'transparent', cursor: 'pointer', color: '#5B6B79', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, boxShadow: showdata ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}
                    >
                      <i className="ti ti-adjustments-horizontal" />
                    </button>
                    {/* Calendar & List views — not usable on phones, hidden below 768px */}
                    {!isMobilePhone && (
                      <>
                        <button
                          onClick={handleclickchange}
                          title="Calendar View"
                          style={{ width: 30, height: 28, border: 'none', borderRadius: 6, background: viewMode === 'calendar' ? '#fff' : 'transparent', cursor: 'pointer', color: viewMode === 'calendar' ? '#4680ff' : '#5B6B79', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, boxShadow: viewMode === 'calendar' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}
                        >
                          <i className="fa fa-calendar" />
                        </button>
                        <button
                          onClick={handleclickchange11}
                          title="List View"
                          style={{ width: 30, height: 28, border: 'none', borderRadius: 6, background: viewMode === 'list' ? '#fff' : 'transparent', cursor: 'pointer', color: viewMode === 'list' ? '#4680ff' : '#5B6B79', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, boxShadow: viewMode === 'list' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}
                        >
                          <i className="fa fa-list" />
                        </button>
                      </>
                    )}
                    {/* Card view */}
                    <button
                      onClick={handleclickchangeCard}
                      title="Card View"
                      style={{ width: 30, height: 28, border: 'none', borderRadius: 6, background: viewMode === 'card' ? '#fff' : 'transparent', cursor: 'pointer', color: viewMode === 'card' ? '#4680ff' : '#5B6B79', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, boxShadow: viewMode === 'card' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}
                    >
                      <i className="ti ti-layout-cards" />
                    </button>
                  </div>

                  {/* Date picker area */}
                  {showdata ? (
                    /* Range mode */
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                      <div style={{ position: 'relative' }}>
                        <DatePicker
                          range
                          value={selectedDates}
                          onChange={setSelectedDates}
                          format="YYYY-MM-DD"
                          placeholder="Select Date Range"
                          inputClass="form-control py-1"
                          className="custom-calendar-style"
                        />
                        <i className="fa fa-calendar position-absolute" style={{ right: 10, top: '50%', transform: 'translateY(-50%)', color: '#888', pointerEvents: 'none' }} />
                      </div>
                      <button
                        onClick={handleMultiDateFilter123}
                        className="btn btn-outline-primary btn-sm rounded-5"
                        title="Search"
                      >
                        <i className="fa fa-search" />
                      </button>
                    </div>
                  ) : (
                    /* Single date mode */
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <div style={{ position: 'relative' }}>
                          <DatePicker
                            value={selectedDate ? selectedDate.toDate() : null}
                            onChange={setSelectedDate}
                            format="YYYY-MM-DD"
                            placeholder="Select Date"
                            inputClass="form-control py-1"
                            className="custom-calendar-style"
                          />
                          <i className="fa fa-calendar position-absolute" style={{ right: 10, top: '50%', transform: 'translateY(-50%)', color: '#888', pointerEvents: 'none' }} />
                        </div>
                        <button
                          onClick={handleMultiDateFiltersingledate}
                          className="btn btn-outline-primary btn-sm rounded-5"
                          title="Search"
                        >
                          <i className="fa fa-search" />
                        </button>
                      </div>
                      {/* Day navigation */}
                      <div style={{ display: 'flex', gap: 4 }}>
                        <button
                          onClick={() => { const base = selectedDate ? dayjs(selectedDate.format("YYYY-MM-DD")) : dayjs(); handleDateNav(base.subtract(1, "day")); }}
                          className="bgBtn"
                          style={{ flex: 1, padding: '3px 6px', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}
                          title="Previous Day"
                        >
                          <i className="fa fa-chevron-left" style={{ fontSize: 10 }} /> Back
                        </button>
                        <button
                          onClick={() => handleDateNav(dayjs())}
                          className="bgBtn"
                          style={{ flex: 1, padding: '3px 6px', fontSize: 12 }}
                          title="Today"
                        >
                          Today
                        </button>
                        <button
                          onClick={() => { const base = selectedDate ? dayjs(selectedDate.format("YYYY-MM-DD")) : dayjs(); handleDateNav(base.add(1, "day")); }}
                          className="bgBtn"
                          style={{ flex: 1, padding: '3px 6px', fontSize: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 3 }}
                          title="Next Day"
                        >
                          Next <i className="fa fa-chevron-right" style={{ fontSize: 10 }} />
                        </button>
                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
            {showModaledit && (() => {
              const editIsBooked = (slot) => {
                const slotMin = toMins(slot);
                const slotEnd = slotMin + 10;
                return editModalBookedSlots.some(({ startTime, endTime }) => {
                  if (!startTime || !endTime) return false;
                  const bStart = toMins(startTime.substring(0, 5));
                  const bEnd = toMins(endTime.substring(0, 5));
                  return slotMin < bEnd && slotEnd > bStart;
                });
              };
              const editIsPast = (slot) => {
                if (appointmentdata1?.appointmentDate !== dayjs().format('YYYY-MM-DD')) return false;
                const now = dayjs();
                return toMins(slot) < now.hour() * 60 + now.minute();
              };
              const editIsInRange = (slot) => {
                if (!appointmentdata1?.startTime || !appointmentdata1?.endTime) return false;
                const slotMin = toMins(slot);
                return slotMin >= toMins(appointmentdata1.startTime) && slotMin < toMins(appointmentdata1.endTime);
              };
              const eSection = (text) => (
                <div style={{ fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10, paddingBottom: 6, borderBottom: '1px solid #f0f2f5' }}>{text}</div>
              );
              const eLabel = (text, req) => (
                <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>{text}{req && <span style={{ color: '#e74c3c', marginLeft: 2 }}>*</span>}</label>
              );
              const inputStyle = { height: 36, fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 8, padding: '0 10px', width: '100%', outline: 'none', color: '#374151', background: '#fff' };
              const editDurMins = appointmentdata1?.startTime && appointmentdata1?.endTime
                ? toMins(appointmentdata1.endTime) - toMins(appointmentdata1.startTime)
                : null;
              const isWaitingType = appointmentdata1.status === "Waiting";

              return (
                <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
                  <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e8ecf0', width: '100%', maxWidth: 620, maxHeight: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 40px rgba(0,0,0,0.18)', overflow: 'hidden' }}>

                    {/* Header */}
                    <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: '#2CA87F15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <i className="ti ti-edit" style={{ color: '#2CA87F', fontSize: 17 }} />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>Edit Appointment</div>
                        <div style={{ fontSize: 11, color: '#5B6B79' }}>
                          {appointmentdata1?.patientName
                            ? <>Updating appointment for <strong>{appointmentdata1.patientName}</strong></>
                            : 'Update appointment details'}
                        </div>
                      </div>
                      <button onClick={handleclose111dff}
                        style={{ width: 28, height: 28, borderRadius: 7, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}
                        onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#dc2626'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79'; }}
                      ><i className="ti ti-x" /></button>
                    </div>

                    {/* Body */}
                    <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>

                      {/* Patient (read-only context) */}
                      {(appointmentdata1?.patientName || appointmentdata1?.mobileNumber) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', borderRadius: 8, background: '#f8f9fb', border: '1px solid #e8ecf0', marginBottom: 22 }}>
                          <i className="ti ti-user" style={{ color: '#5B6B79', fontSize: 16 }} />
                          <div>
                            <div style={{ fontSize: 13, fontWeight: 600, color: '#1a202c' }}>{appointmentdata1?.patientName || '—'}</div>
                            {appointmentdata1?.mobileNumber && <div style={{ fontSize: 11, color: '#5B6B79' }}>{appointmentdata1.mobileNumber}</div>}
                          </div>
                        </div>
                      )}

                      {/* Doctor & Date */}
                      {eSection('Doctor & Date')}
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 22 }}>
                        <div>
                          {eLabel('Doctor', true)}
                          <select name="doctorId" value={appointmentdata1.doctorId || ''} onChange={handleChange23} style={inputStyle}>
                            <option value="">Select doctor…</option>
                            {doctors?.map((doctor) => (
                              <option key={doctor.id} value={String(doctor.id)}>{doctor.displayName}</option>
                            ))}
                          </select>
                        </div>
                        <div>
                          {eLabel('Date', true)}
                          <input type="date" name="appointmentDate" value={appointmentdata1.appointmentDate || ''} onChange={handleChange23} style={inputStyle} />
                        </div>
                      </div>

                      {/* Type */}
                      {eSection('Type')}
                      <div style={{ display: 'flex', gap: 8, marginBottom: 22, flexWrap: 'wrap' }}>
                        {[
                          { value: 'Waiting', label: 'Waiting', icon: 'ti-clock', color: '#f39c12' },
                          { value: 'Emergency', label: 'Emergency', icon: 'ti-urgent', color: '#e74c3c' },
                        ].map(({ value, label, icon, color }) => {
                          const active = appointmentdata1.status === value;
                          return (
                            <button key={value} type="button"
                              onClick={() => handleChange23({ target: { name: 'status', value: active ? '' : value } })}
                              style={{ padding: '6px 14px', borderRadius: 20, border: `1.5px solid ${color}`, background: active ? color : 'transparent', color: active ? '#fff' : color, cursor: 'pointer', fontSize: 12, fontWeight: 500, display: 'flex', alignItems: 'center', gap: 5, transition: 'all 0.15s' }}
                            >
                              <i className={`ti ${icon}`} style={{ fontSize: 13 }} />{label}
                            </button>
                          );
                        })}
                      </div>

                      {/* Time Slot */}
                      {!isWaitingType && (
                        <>
                          {eSection('Time Slot')}
                          <div style={{ border: '1px solid #e9ecef', borderRadius: 10, padding: '14px 16px', marginBottom: 22 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                              <div style={{ display: 'flex', borderRadius: 8, border: '1px solid #dee2e6', overflow: 'hidden' }}>
                                {[{ key: 'slots', label: 'Suggest Slots' }, { key: 'manual', label: 'Manual' }].map(({ key, label }) => (
                                  <button key={key} type="button" onClick={() => setEditModalTimeMode(key)}
                                    style={{ padding: '5px 14px', background: editModalTimeMode === key ? '#2ca87f' : '#fff', color: editModalTimeMode === key ? '#fff' : '#666', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: editModalTimeMode === key ? 600 : 400, transition: 'background 0.15s' }}
                                  >{label}</button>
                                ))}
                              </div>
                              {editModalLoadingSlots && <span style={{ fontSize: 11, color: '#aaa' }}>Loading…</span>}
                              {editDurMins !== null && editDurMins > 0 && (
                                <span style={{ fontSize: 11, color: '#2ca87f', fontWeight: 600, marginLeft: 'auto' }}>
                                  <i className="ti ti-clock me-1" />{editDurMins} min
                                </span>
                              )}
                            </div>

                            {editModalTimeMode === 'slots' && (
                              !appointmentdata1?.doctorId || !appointmentdata1?.appointmentDate
                                ? <p style={{ color: '#bbb', fontSize: 12, margin: '4px 0 10px' }}>Select a doctor and date to see available slots.</p>
                                : <>
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, maxHeight: 160, overflowY: 'auto', paddingBottom: 4 }}>
                                    {bookAllTimeSlots.map((slot) => {
                                      const booked = editIsBooked(slot);
                                      const past = editIsPast(slot);
                                      const disabled = booked || past;
                                      const inRange = editIsInRange(slot);
                                      const isStart = slot === appointmentdata1?.startTime;
                                      return (
                                        <button key={slot} type="button" disabled={disabled} onClick={() => handleEditSlotClick(slot)}
                                          title={booked ? 'Already booked' : past ? 'Time has passed' : `Select ${toAmPmW(slot)}`}
                                          style={{ padding: '3px 9px', borderRadius: 5, border: `1.5px solid ${disabled ? '#e9ecef' : inRange ? '#2ca87f' : '#ddd'}`, background: disabled ? '#f8f9fa' : isStart ? '#2ca87f' : inRange ? '#e6f4ef' : '#fff', color: disabled ? '#ccc' : isStart ? '#fff' : inRange ? '#2ca87f' : '#444', fontSize: 11, cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: isStart ? 700 : 400, textDecoration: booked ? 'line-through' : 'none', transition: 'all 0.1s' }}
                                        >{toAmPmW(slot)}</button>
                                      );
                                    })}
                                  </div>
                                  <div style={{ display: 'flex', gap: 12, marginTop: 6, fontSize: 10, color: '#999' }}>
                                    <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: '#2ca87f', marginRight: 3 }} />Start</span>
                                    <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: '#e6f4ef', border: '1px solid #2ca87f', marginRight: 3 }} />Duration</span>
                                    <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: '#f8f9fa', border: '1px solid #e9ecef', marginRight: 3 }} />Booked / Past</span>
                                  </div>
                                </>
                            )}

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 14 }}>
                              <div>
                                {eLabel('Start Time', true)}
                                <input type="time" name="startTime" value={appointmentdata1.startTime || ''} onChange={handleChange23} style={inputStyle} />
                              </div>
                              <div>
                                {eLabel('End Time', true)}
                                <input type="time" name="endTime" value={appointmentdata1.endTime || ''} onChange={handleChange23} style={inputStyle} />
                              </div>
                            </div>
                            {editDurMins !== null && editDurMins <= 0 && (
                              <div style={{ fontSize: 11, color: '#e74c3c', marginTop: 5 }}>End time must be after start time</div>
                            )}
                          </div>
                        </>
                      )}

                      {/* Reason */}
                      {eSection('Reason')}
                      <div style={{ marginBottom: 4 }}>
                        <textarea
                          placeholder="Enter reason"
                          name="reason"
                          value={appointmentdata1.reason || ''}
                          onChange={handleChange23}
                          rows={3}
                          style={{ ...inputStyle, height: 'auto', minHeight: 72, padding: '8px 10px', resize: 'vertical' }}
                        />
                      </div>
                    </div>

                    {/* Footer */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '14px 20px', borderTop: '1px solid #e8ecf0', flexShrink: 0 }}>
                      <button className="cancelBtn" onClick={handleclose111dff}>Cancel</button>
                      <button className="bgBtn" onClick={() => updateAppointment()}>
                        <i className="ti ti-check me-1" />Update Appointment
                      </button>
                    </div>
                  </div>
                </div>
              );
            })()}
            {showModalDoctor && (
              <div
                className="modal fade show"
                style={{
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "block",
                }}
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Filter By Doctor</h5>
                    </div>
                    <div className="modal-body appointmentDetails">
                      {(() => {
                        const visibleDoctors = allowedDoctorIds.length > 0
                          ? (doctors || []).filter(d => allowedDoctorIds.includes(String(d.id)))
                          : (doctors || []);
                        const allVisible = visibleDoctors.length > 0 && visibleDoctors.every(d => selectedDoctors.includes(String(d.id)));
                        return (
                          <div className="row">
                            {visibleDoctors.length > 0 ? (
                              <>
                                <div className="col-12 mb-3">
                                  <label className="form-check-label d-flex align-items-center gap-2" htmlFor="selectAllDoctors">
                                    <input type="checkbox" id="selectAllDoctors" checked={allVisible}
                                      onChange={e => {
                                        const ids = visibleDoctors.map(d => String(d.id));
                                        if (e.target.checked) {
                                          setSelectedDoctors(prev => [...new Set([...prev, ...ids])]);
                                          setArrayuser(prev => [...new Set([...prev, ...ids])]);
                                        } else {
                                          setSelectedDoctors(prev => prev.filter(id => !ids.includes(id)));
                                          setArrayuser(prev => prev.filter(id => !ids.includes(id)));
                                        }
                                      }}
                                      style={{ cursor: "pointer" }} />
                                    Select All Doctors
                                  </label>
                                </div>
                                {visibleDoctors.map((item, index) => (
                                  <div className="col-md-4" key={index}>
                                    <div className="mb10">
                                      <label className="form-check-label d-flex align-items-center gap-2" htmlFor={`doctor-${item.id}`}>
                                        <input type="checkbox" id={`doctor-${item.id}`} value={item.id} name="doctorIds"
                                          style={{ cursor: "pointer" }}
                                          checked={selectedDoctors.includes(String(item.id))}
                                          onChange={handlechange11} />
                                        {item.displayName}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <div className="col-12"><p>No doctors available</p></div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                    <siv className="d-flex justify-content-end modal-footer">
                      <button onClick={handleclose111} className="cancelText">
                        Cancel
                      </button>
                      <button
                        className=" my-3 bgBtn"
                        onClick={() => {
                          // setFunction();
                          // setFunction123();
                          applyUnifiedFilter();
                        }}
                      >
                        Filter{" "}
                      </button>
                    </siv>
                  </div>
                </div>
              </div>
            )}
            {showModalDoctor23 && (
              <div
                className="modal fade show"
                style={{
                  backgroundColor: "rgba(0,0,0,0.5)",
                  display: "block",
                }}
              >
                <div className="modal-dialog modal-lg">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Filter By Doctor</h5>
                    </div>
                    <div className="modal-body appointmentDetails">
                      {(() => {
                        const visibleDoctors = allowedDoctorIds.length > 0
                          ? (doctors || []).filter(d => allowedDoctorIds.includes(String(d.id)))
                          : (doctors || []);
                        const allVisible = visibleDoctors.length > 0 && visibleDoctors.every(d => selectedDoctors.includes(String(d.id)));
                        return (
                          <div className="row">
                            {visibleDoctors.length > 0 ? (
                              <>
                                <div className="col-12 mb-3">
                                  <div>
                                    <input type="checkbox" id="selectAllDoctors2" checked={allVisible}
                                      onChange={e => {
                                        const ids = visibleDoctors.map(d => String(d.id));
                                        if (e.target.checked) {
                                          const merged = [...new Set([...selectedDoctors, ...ids])];
                                          setSelectedDoctors(merged);
                                          setArrayuser(merged);
                                          localStorage.setItem("userarray", JSON.stringify({ data: merged }));
                                        } else {
                                          const trimmed = selectedDoctors.filter(id => !ids.includes(id));
                                          setSelectedDoctors(trimmed);
                                          setArrayuser(trimmed);
                                          localStorage.setItem("userarray", JSON.stringify({ data: trimmed }));
                                        }
                                      }}
                                      style={{ cursor: "pointer" }} />
                                    <label className="form-check-label ms-2" htmlFor="selectAllDoctors2">Select All Doctors</label>
                                  </div>
                                </div>
                                {visibleDoctors.map((item, index) => (
                                  <div className="col-md-4" key={index}>
                                    <div>
                                      <input type="checkbox" id={`doctor2-${item.id}`} value={item.id} name="doctorIds"
                                        style={{ cursor: "pointer" }}
                                        checked={selectedDoctors.includes(String(item.id))}
                                        onChange={handlechange11} />
                                      <label className="form-check-label ms-2 bg-blue-important" htmlFor={`doctor2-${item.id}`}>
                                        {item.displayName}
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <div className="col-12"><p>No doctors available</p></div>
                            )}
                          </div>
                        );
                      })()}
                    </div>
                    <siv className="d-flex justify-content-end modal-footer">
                      <button
                        onClick={handlelcicktoope1111nFALSE}
                        className="cancelText"
                      >
                        Cancel
                      </button>
                      <button
                        className=" my-3 bgBtn"
                        // onClick={async () => {
                        //   // Fetch current date's filtered data for list view
                        //   if (arrayuser.length > 0) {
                        //     const today = new Date().toISOString().split('T')[0];
                        //     try {
                        //       const response = await axiosInstance.post(
                        //         `getAppointmentsByDoctorAndDate`,
                        //         {
                        //           startDate: today,
                        //           endDate: today,
                        //           doctorIds: arrayuser,
                        //         }
                        //       );
                        //       if (response?.data?.success && response.data.data?.length > 0) {
                        //         setAppointmentdata(response.data.data);
                        //         setAppointmentdata12(response.data.data);
                        //         setDuplicateArray(response.data.data);
                        //         savedoctor();
                        //         handlelcicktoope1111nFALSE();
                        //       } else {
                        //         setAppointmentdata([]);
                        //         setAppointmentdata12([]);
                        //         setDuplicateArray([]);
                        //         handlelcicktoope1111nFALSE();
                        //         Swal.fire({
                        //           icon: "info",
                        //           title: "No Data",
                        //           text: "No appointments found for selected doctors today",
                        //         });
                        //       }
                        //     } catch (error) {
                        //       console.error("Error fetching filtered data:", error);
                        //       Swal.fire("Error!", error.message || "Something went wrong", "error");
                        //     }
                        //   } else {
                        //     Swal.fire({
                        //       icon: "warning",
                        //       title: "No Doctor Selected",
                        //       text: "Please select at least one doctor",
                        //     });
                        //   }
                        // }}
                        onClick={
                          () => {
                            applyUnifiedFilter();
                          }
                        }
                      >
                        Filter{" "}
                      </button>
                    </siv>
                  </div>
                </div>
              </div>
            )}
            {showdata ? (
              <div class="card table-card">
                <div className="">
                  <div className="card-header bg-white py-3" style={{ borderBottom: "1px solid #f0f0f0" }}>
                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">

                      {/* Status Filter Buttons */}
                      <div className="d-flex align-items-center gap-2">
                        {(() => {
  const allCount       = appointmentdata12.length;
  const completedCount = appointmentdata12.filter(i => i.status?.toLowerCase() === "completed").length;
  const pendingCount   = allCount - completedCount;

  return [
    { key: "all",       label: "All",       count: allCount       },
    { key: "pending",   label: "Pending",   count: pendingCount   },
    { key: "completed", label: "Completed", count: completedCount },
  ];
})().map(({ key, label, count }) => (
                          <button
                            key={key}
                            onClick={() => { setStatusFilter(key); setCurrentPage(1); }}
                            style={{
                              padding: "6px 18px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: statusFilter === key ? "600" : "400",
                              border: statusFilter === key ? "none" : "1px solid #dee2e6",
                              background: statusFilter === key
                                ? key === "completed" ? "#d4edda"
                                  : key === "pending"   ? "#fff3cd"
                                  : "#4680ff"
                                : "#fff",
                              color: statusFilter === key
                                ? key === "completed" ? "#155724"
                                  : key === "pending"   ? "#856404"
                                  : "#fff"
                                : "#6c757d",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              boxShadow: statusFilter === key ? "0 2px 6px rgba(0,0,0,0.12)" : "none",
                            }}
                          >
                            {label} <span style={{ opacity: 0.75, fontWeight: "400" }}>({count})</span>

                          </button>
                        ))}
                      </div>

                      {/* Branch Filter */}
                      {allBranchSettings && allBranchSettings.length > 1 && (
                        <select
                          value={branchFilter}
                          onChange={e => { setBranchFilter(e.target.value); setCurrentPage(1); }}
                          style={{
                            height: 36, borderRadius: 8, border: "1px solid #dee2e6",
                            padding: "0 10px", fontSize: 13, color: branchFilter !== "all" ? "#4680ff" : "#6c757d",
                            background: "#fff", cursor: "pointer", outline: "none",
                            fontWeight: branchFilter !== "all" ? 600 : 400,
                            minWidth: 130,
                          }}
                        >
                          <option value="all">All Branches</option>
                          {allBranchSettings.map((b, i) => (
                            <option key={b.id} value={String(b.id)}>
                              Branch {i + 1}{b.official_name ? ` — ${b.official_name}` : ""}
                            </option>
                          ))}
                        </select>
                      )}

                      {/* Search Box */}
                      <div className="tableSearch" style={{ minWidth: "260px", flex: "1", maxWidth: "380px" }}>
                        <input
                          type="text"
                          placeholder="Search by name, or mobile"
                          className="form-control"
                          style={{ paddingLeft: "36px", borderRadius: "8px", fontSize: "13px", height: "38px" }}
                          value={searchTerm}
                          onChange={handleSearchChange}
                        />
                        <span className="searchIcon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="gray"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "10px",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                            }}
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z" />
                          </svg>
                        </span>
                      </div>

                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table m-0" id="pc-dt-simple" style={{ fontSize: "13.5px" }}>
                        <thead style={{ background: "#f8f9fa", borderBottom: "2px solid #e9ecef" }}>
                          <tr>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057", whiteSpace: "nowrap" }}>SR No.</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057", whiteSpace: "nowrap" }}>Appointment Date</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>Doctor</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>Patient</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>Reason</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057", whiteSpace: "nowrap" }}>Time</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>Duration</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057", whiteSpace: "nowrap" }}>Phone Number</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>Status</th>
                            <th style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>No-show Risk</th>
                            <th className="text-center" style={{ padding: "12px 16px", fontWeight: "600", color: "#495057" }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentPatients && currentPatients.length > 0 ? (
                            currentPatients.map((item, index) => {
                              return (
                                <tr key={index} style={{ borderBottom: "1px solid #f0f0f0", transition: "background 0.15s" }}
                                  onMouseEnter={e => e.currentTarget.style.background = "#fafbff"}
                                  onMouseLeave={e => e.currentTarget.style.background = ""}
                                >
                                  <td style={{ padding: "11px 16px", color: "#6c757d", fontWeight: "500" }}>{indexOfFirst + index + 1}</td>
                                  <td style={{ padding: "11px 16px", whiteSpace: "nowrap" }} className="mb-0">
                                    {new Date(
                                      item.appointmentDate
                                    ).toLocaleDateString("en-GB")}
                                  </td>
                                  <td style={{ padding: "11px 16px" }}>{item.displayName}</td>
                                 <td style={{ padding: "11px 16px" }}>
                                    {item.patientId && item.patientId !== 0 ? (
                                         <NavLink
                                            to="/Admin/Manageappointment"
                                           state={{
                                            patientid: {
                                                ...item,
                                                 id: item.patientId || item.patient_id,
                                                    },
                                                      }}
                                    style={{ textDecoration: "none", color: "black", display: "flex", alignItems: "center", gap: "8px" }}
                                            >
                                           <img
                                           src={item.profileImage ? `${baseurImage}${item.profileImage}` : "/assets/images/user/avatar-1.jpg"}
                                               alt=""
                                     title={item.hasInsurance == 1 ? "Active Insurance" : undefined}
                                     style={{ width: "34px", height: "34px", borderRadius: "8px", objectFit: "cover", flexShrink: 0, border: item.hasInsurance == 1 ? "2px solid #f5c518" : "1px solid #e9ecef" }}
                                          />
                                          {item.patientName || item.onlinePatientName || "-"}
                                             </NavLink>
                                            ) : (
    <span style={{ color: "black", display: "flex", alignItems: "center", gap: "8px" }}>
      <img
        src={item.profileImage ? `${baseurImage}${item.profileImage}` : "/assets/images/user/avatar-1.jpg"}
        alt=""
        title={item.hasInsurance == 1 ? "Active Insurance" : undefined}
        style={{ width: "34px", height: "34px", borderRadius: "8px", objectFit: "cover", flexShrink: 0, border: item.hasInsurance == 1 ? "2px solid #f5c518" : "1px solid #e9ecef" }}
      />
      {item.patientName || item.onlinePatientName || "-"}
    </span>
  )}
</td>

                                  <td style={{ padding: "11px 16px", color: "#555" }}>
                                    {item.reason?.length > 20
                                      ? `${item.reason.slice(0, 20)}...`
                                      : item.reason}
                                  </td>
                                  <td style={{ padding: "11px 16px", whiteSpace: "nowrap" }}>
                                    {item?.startTime && item?.endTime ? (
                                      <>
                                        {new Date(
                                          `1970-01-01T${item.startTime}`
                                        ).toLocaleTimeString("en-US", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}{" "}
                                        /{" "}
                                        {new Date(
                                          `1970-01-01T${item.endTime}`
                                        ).toLocaleTimeString("en-US", {
                                          hour: "2-digit",
                                          minute: "2-digit",
                                          hour12: true,
                                        })}
                                      </>
                                    ) : (
                                      <span className="text-muted" style={{ fontSize: "12px" }}>
                                        Not Scheduled
                                      </span>
                                    )}
                                  </td>
                                  <td style={{ padding: "11px 16px" }}>{item?.duration}</td>
                                  <td style={{ padding: "11px 16px", whiteSpace: "nowrap" }}>{item?.mobileNumber}</td>
                                  <td className="statusSelect" style={{ padding: "11px 16px" }}>
                                    <select
                                      onChange={(e) =>
                                        handlechangeDropdownData(e, item.id)
                                      }
                                      style={{
                                        cursor: "pointer",
                                        borderRadius: "6px",
                                        padding: "4px 8px",
                                        fontSize: "12px",
                                        fontWeight: "500",
                                        border: "none",
                                        ...(statusColors[item?.status] || {
                                          backgroundColor: "#fff",
                                          color: "#000",
                                        }),
                                      }}
                                      name="status"
                                      value={item?.status}
                                    >
                                      <option value="">Select</option>
                                      <option value="No-show">No-show</option>
                                      <option value="Completed">Completed</option>
                                      <option value="Cancelled">Cancelled</option>
                                      <option value="Booked">Booked</option>
                                      <option value="Waiting">Waiting</option>
                                      <option value="Confirmed">Confirmed</option>
                                      <option value="Emergency">Emergency</option>
                                    </select>
                                  </td>
                                  <td style={{ padding: "11px 16px" }}>
                                    {(item.status === "Booked" || item.status === "Confirmed") && noShowRiskById[item.id] ? (
                                      <span
                                        title={noShowRiskById[item.id].reasons?.join(" | ")}
                                        style={{
                                          display: "inline-block",
                                          padding: "4px 10px",
                                          borderRadius: "6px",
                                          fontSize: "12px",
                                          fontWeight: 500,
                                          opacity: noShowRiskById[item.id].confidence === "low" ? 0.6 : 1,
                                          cursor: "default",
                                          ...(riskBadgeConfig[noShowRiskById[item.id].bucket] || riskBadgeConfig.low),
                                        }}
                                      >
                                        {riskBadgeConfig[noShowRiskById[item.id].bucket]?.label || "Low"}
                                        {noShowRiskById[item.id].confidence === "low" ? " (new)" : ""}
                                      </span>
                                    ) : (
                                      <span style={{ color: "#adb5bd", fontSize: "12px" }}>—</span>
                                    )}
                                  </td>
                                  <td className="text-center" style={{ padding: "11px 16px" }}>
                                    <div
                                      className="avtar avtar-xs btn-link-secondary viewIcon"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        Openmodalfunction(item);
                                      }}
                                    >
                                      <i className="ti ti-eye f-20" />
                                      <span>View</span>
                                    </div>
                                    <div
                                      onClick={() => {
                                        handledopencllick(item);
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="avtar avtar-xs btn-link-secondary editIcon"
                                    >
                                      <i className="ti ti-edit f-20" />
                                      <span>Edit</span>
                                    </div>
                                    <div
                                      onClick={() => {
                                        handledelet(item.id);
                                      }}
                                      style={{ cursor: "pointer" }}
                                      className="avtar avtar-xs btn-link-secondary deleteIcon"
                                    >
                                      <i className="ti ti-trash f-20" />
                                      <span>Delete</span>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="100%" className="text-center py-5 text-muted" style={{ fontSize: "14px" }}>
                                No Data Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {totalPages > 1 && (
                        <nav className="tablepagination">
                          <ul className="pagination justify-content-end mb-0 me-3">
                            <li
                              className={`page-item ${currentPage === 1 ? "disabled" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  currentPage > 1 && setCurrentPage(currentPage - 1)
                                }
                              >
                                &laquo;
                              </button>
                            </li>
                            <li className="pageNmbr">{`${currentPage} of ${totalPages}`}</li>
                            <li
                              className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() =>
                                  currentPage < totalPages &&
                                  setCurrentPage(currentPage + 1)
                                }
                              >
                                &raquo;
                              </button>
                            </li>
                          </ul>
                        </nav>
                      )}
                      {videwmodapopen && (
                        <div
                          className="modal fade show"
                          style={{
                            backgroundColor: "rgba(0,0,0,0.5)",
                            display: "block",
                          }}
                        >
                          <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                              <div className="modal-header">
                                <h5 className="modal-title">Appointment Details</h5>
                              </div>
                              <div className="modal-body appointmentDetails">
                                <div>
                                  <div className="row">
                                    <div className="col-md-12">
                                      <div style={{ position: "relative" }}>
                                        <div className="personaimg text-center">
                                          {appointviewdata?.profileImage && (
                                            <img
                                              src={`${baseurImage}${appointviewdata.profileImage}`}
                                              alt="patient"
                                              className="rounded-circle"
                                              style={{
                                                width: "100px",
                                                height: "100px",
                                                objectFit: "cover",
                                              }}
                                            />
                                          )}
                                        </div>
                                        <div>
                                          <div className="row p20">
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Doctor Name
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                value={appointviewdata.doctorName}
                                                placeholder="  Doctor Name"
                                                disabled
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Patient Name
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Name"
                                                disabled
                                                value={appointviewdata.patientName}
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Age
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Age"
                                                disabled
                                                value={appointviewdata.age || ""}
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Start Time
                                              </label>
                                              <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value={
                                                  appointviewdata.startTime
                                                    ? new Date(
                                                      `1970-01-01T${appointviewdata.startTime}`
                                                    ).toLocaleTimeString(
                                                      "en-US",
                                                      {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                      }
                                                    )
                                                    : ""
                                                }
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                End Time
                                              </label>
                                              <input
                                                type="text"
                                                disabled
                                                className="form-control"
                                                value={
                                                  appointviewdata.endTime
                                                    ? new Date(
                                                      `1970-01-01T${appointviewdata.endTime}`
                                                    ).toLocaleTimeString(
                                                      "en-US",
                                                      {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                        hour12: true,
                                                      }
                                                    )
                                                    : ""
                                                }
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Date
                                              </label>
                                              <input
                                                type="date"
                                                disabled
                                                className="form-control"
                                                value={
                                                  appointviewdata?.appointmentDate
                                                    ? new Date(
                                                      appointviewdata?.appointmentDate
                                                    )
                                                      .toISOString()
                                                      .split("T")[0]
                                                    : ""
                                                }
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Status
                                              </label>
                                              <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Status"
                                                disabled
                                                value={appointviewdata.status}
                                              />
                                            </div>
                                            <div className="col-md-6">
                                              <label className="form-label">
                                                Reason
                                              </label>
                                              <textarea
                                                type="text"
                                                className="form-control"
                                                placeholder="Reason"
                                                disabled
                                                value={appointviewdata.reason}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-md-4 rightSidePer"></div>
                                  </div>
                                </div>
                              </div>
                              {appointviewdata?.status === "Completed" ? null : (
                                <div className="modal-footer d-flex justify-content-end" style={{ gap: "6px" }}>
                                  {appointviewdata?.status === "Cancelled" ? null : (
                                    <button
                                      className="cancelBtn"
                                      style={{ fontSize: "12px", padding: "4px 12px" }}
                                      onClick={() => {
                                        closeCalendarModal1111();
                                        handleclickcancleapoointment(appointviewdata);
                                      }}
                                    >
                                      Cancelled
                                    </button>
                                  )}
                                  {appointviewdata?.status === "Confirmed" ? null : (
                                    <button
                                      className="borderBtn"
                                      style={{ fontSize: "12px", padding: "4px 12px" }}
                                      onClick={() => {
                                        closeCalendarModal1111();
                                        handleupdateconfirm(appointviewdata);
                                      }}
                                    >
                                      Confirmed
                                    </button>
                                  )}
                                  <button
                                    className="bgBtn"
                                    style={{ fontSize: "12px", padding: "4px 12px", background: "#28a745", borderColor: "#28a745" }}
                                    onClick={async () => {
                                      try {
                                        const response = await axiosInstance.post(
                                          `changeAppointmentStatus/${appointviewdata.id}`,
                                          { status: "Completed" }
                                        );
                                        if (response.data.success === true) {
                                          const userid11 = JSON.parse(localStorage.getItem("userarray"));
                                          const freshDoctorIds = userid11?.data || [];
                                          if (freshDoctorIds.length > 0) {
                                            const sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
                                            await syncFiltersAndFetch(sDate, sDate, freshDoctorIds, 'single');
                                          }
                                          closeCalendarModal1111();
                                          Swal.fire("Success", "Appointment marked as Completed", "success");
                                        }
                                      } catch (error) {
                                        console.error("Error:", error.message);
                                      }
                                    }}
                                  >
                                    Completed
                                  </button>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="">
                <div className="">

                  {viewMode === "calendar" && (() => {
                    const whStart = (clinicWorkingHours.start_time || "07:00:00").slice(0, 5);
                    const whEnd = (clinicWorkingHours.end_time || "20:00:00").slice(0, 5);
                    const [whStartH, whStartM] = whStart.split(':').map(Number);
                    const [whEndH, whEndM] = whEnd.split(':').map(Number);
                    const whStartSlotIndex = Math.floor((whStartH * 60 + whStartM) / 30);
                    const whEndSlotIndex = Math.ceil((whEndH * 60 + whEndM) / 30);
                    const whSlotCount = Math.max(1, whEndSlotIndex - whStartSlotIndex);
                    return (
                    <div style={{ borderRadius: 10, overflow: 'hidden', border: '1px solid #dce3ea', background: '#fff', marginBottom: 16 }}>
                      {/* Working hours label */}
                      <div style={{ padding: '6px 12px', background: '#f4f7fa', borderBottom: '1px solid #dce3ea', display: 'flex', alignItems: 'center', gap: 8 }}>
                        <i className="ti ti-clock" style={{ color: '#2a5478', fontSize: 13 }} />
                        <span style={{ fontSize: 11, color: '#2a5478', fontWeight: 600 }}>
                          Working Hours: {dayjs(`2023-01-01T${whStart}`).format('h:mm A')} – {dayjs(`2023-01-01T${whEnd}`).format('h:mm A')}
                        </span>
                        <span style={{ fontSize: 11, color: '#888', marginLeft: 'auto' }}>{appointmentpatiemt.length} doctor{appointmentpatiemt.length !== 1 ? 's' : ''}</span>
                      </div>

                      {/* Scrollable grid area */}
                      <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: 'calc(100vh - 320px)' }}>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: `62px repeat(${appointmentpatiemt.length}, minmax(150px, 1fr))`,
                          gridTemplateRows: `38px repeat(${whSlotCount}, 72px)`,
                          minWidth: appointmentpatiemt.length > 0 ? `${62 + appointmentpatiemt.length * 150}px` : '100%',
                        }}>

                          {/* Top-left corner */}
                          <div style={{
                            gridRow: 1, gridColumn: 1,
                            background: '#2a5478',
                            borderRight: '1px solid #1e3f5a',
                            borderBottom: '2px solid #1a3f5a',
                            position: 'sticky', top: 0, left: 0, zIndex: 15,
                          }} />

                          {/* Doctor header cells */}
                          {appointmentpatiemt.map((doc, i) => {
                            if (!doc?.displayName) return null;
                            const name = doc.displayName.trim().replace(/\b\w/g, c => c.toUpperCase());
                            return (
                              <div key={i} style={{
                                gridRow: 1, gridColumn: i + 2,
                                background: '#2a5478',
                                color: '#fff',
                                fontSize: 12,
                                fontWeight: 600,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                textAlign: 'center',
                                padding: '0 8px',
                                borderRight: i < appointmentpatiemt.length - 1 ? '1px solid #1e3f5a' : 'none',
                                borderBottom: '2px solid #1a3f5a',
                                position: 'sticky', top: 0, zIndex: 10,
                                letterSpacing: 0.2,
                                gap: 5,
                              }}>
                                <i className="ti ti-stethoscope" style={{ fontSize: 11, opacity: 0.7 }} />
                                {name}
                              </div>
                            );
                          })}

                          {/* Time slots: dynamic, based on clinic working hours */}
                          {Array.from({ length: whSlotCount }, (_, i) => {
                            const slotIndex = i + whStartSlotIndex;
                            const hour = Math.floor(slotIndex / 2);
                            const minute = slotIndex % 2 === 0 ? 0 : 30;
                            const slotStart = hour * 60 + minute;
                            const slotEnd = slotStart + 30;
                            const isHourMark = minute === 0;
                            const timeLabel = dayjs(`2023-01-01T${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`).format('h:mm A');
                            const rowNum = i + 2;
                            return (
                              <React.Fragment key={slotIndex}>

                                {/* Time label cell */}
                                <div style={{
                                  gridRow: rowNum, gridColumn: 1,
                                  background: isHourMark ? '#edf2f7' : '#f7fafc',
                                  fontSize: 10,
                                  fontWeight: isHourMark ? 600 : 400,
                                  color: isHourMark ? '#2a5478' : '#94a3b8',
                                  display: 'flex', alignItems: 'flex-start', justifyContent: 'flex-end',
                                  padding: '3px 6px 0 0',
                                  borderRight: '2px solid #c8d6e5',
                                  borderBottom: isHourMark ? '1px solid #b8cfe0' : '1px solid #edf2f7',
                                  position: 'sticky', left: 0, zIndex: 5,
                                  userSelect: 'none',
                                }}>
                                  {isHourMark ? timeLabel : ''}
                                </div>

                                {/* Appointment cells per doctor */}
                                {appointmentpatiemt.map((doctor, colIdx) => (
                                  <div
                                    key={`${slotIndex}-${colIdx}`}
                                    onClick={() => handleEmptySlotClick(doctor, hour, minute)}
                                    title="Click to book a new appointment at this time"
                                    style={{
                                      gridRow: rowNum, gridColumn: colIdx + 2,
                                      background: isHourMark ? '#fafbfd' : '#ffffff',
                                      borderRight: colIdx < appointmentpatiemt.length - 1 ? '1px solid #edf2f7' : 'none',
                                      borderBottom: isHourMark ? '1px solid #b8cfe0' : '1px solid #edf2f7',
                                      position: 'relative',
                                      cursor: 'pointer',
                                    }}
                                    onMouseEnter={(e) => { e.currentTarget.style.background = '#eef6ff'; }}
                                    onMouseLeave={(e) => { e.currentTarget.style.background = isHourMark ? '#fafbfd' : '#ffffff'; }}
                                  >
                                    {doctor?.appointments
                                      ?.filter(app => app?.status !== 'Waiting')
                                      ?.map((app, ai) => {
                                        if (!app?.startTime || !app?.endTime) return null;
                                        const [sH, sM] = app.startTime.split(':').map(Number);
                                        const [eH, eM] = app.endTime.split(':').map(Number);
                                        const appStart = sH * 60 + sM;
                                        const appEnd = eH * 60 + eM;
                                        if (!(appStart >= slotStart && appStart < slotEnd)) return null;
                                        const durationMin = appEnd - appStart;
                                        const heightPct = (durationMin / 30) * 100;
                                        const offsetPct = ((sM % 30) / 30) * 100;
                                        const st = app?.status || '';
                                        let bg, borderColor, textColor;
                                        if (st === 'Cancelled' || st === 'cancelled') {
                                          bg = '#f5f6f7'; borderColor = '#9e9e9e'; textColor = '#666';
                                        } else if (st === 'Completed' || st === 'completed') {
                                          bg = '#ecfdf5'; borderColor = '#28a745'; textColor = '#166534';
                                        } else if (st === 'Booked' || st === 'booked') {
                                          bg = '#eff6ff'; borderColor = '#4680ff'; textColor = '#1e40af';
                                        } else if (st === 'Emergency' || st === 'emergency') {
                                          bg = '#fef2f2'; borderColor = '#dc3545'; textColor = '#991b1b';
                                        } else {
                                          bg = '#f0fdf8'; borderColor = '#2CA87F'; textColor = '#14532d';
                                        }
                                        return (
                                          <div
                                            key={ai}
                                            onClick={(e) => { e.stopPropagation(); Openmodalfunction(app); }}
                                            onMouseEnter={(e) => handleApptHoverEnter(e, app)}
                                            onMouseLeave={handleApptHoverLeave}
                                            style={{
                                              position: 'absolute',
                                              top: `${offsetPct}%`,
                                              left: 2,
                                              right: 2,
                                              height: `${heightPct}%`,
                                              minHeight: 28,
                                              background: bg,
                                              border: `1.5px solid ${borderColor}`,
                                              borderLeft: `4px solid ${borderColor}`,
                                              borderRadius: 6,
                                              padding: '3px 6px',
                                              fontSize: 12,
                                              color: textColor,
                                              cursor: 'pointer',
                                              overflow: 'hidden',
                                              zIndex: 3,
                                              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                              transition: 'box-shadow 0.15s, transform 0.15s',
                                            }}
                                            onMouseOver={(e) => {
                                              e.currentTarget.style.boxShadow = '0 3px 10px rgba(0,0,0,0.18)';
                                              e.currentTarget.style.transform = 'translateY(-1px)';
                                            }}
                                            onMouseOut={(e) => {
                                              e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.1)';
                                              e.currentTarget.style.transform = '';
                                            }}
                                          >
                                            <div style={{ fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.3' }}>
                                              {app?.patientName || app?.onlinePatientName || '—'}
                                            </div>
                                            <div style={{ fontSize: 12, opacity: 0.8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', lineHeight: '1.2' }}>
                                              {dayjs(`2023-01-01T${app.startTime}`).format('h:mma')}–{dayjs(`2023-01-01T${app.endTime}`).format('h:mma')}
                                            </div>
                                          </div>
                                        );
                                      })}
                                  </div>
                                ))}
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </div>

                      {/* Legend */}
                      <div style={{ display: 'flex', gap: 12, padding: '6px 12px', background: '#f9fafc', borderTop: '1px solid #edf2f7', flexWrap: 'wrap' }}>
                        {[
                          { label: 'Booked',    color: '#4680ff' },
                          { label: 'Confirmed', color: '#2CA87F' },
                          { label: 'Completed', color: '#28a745' },
                          { label: 'Emergency', color: '#dc3545' },
                          { label: 'Cancelled', color: '#9e9e9e' },
                        ].map(({ label, color }) => (
                          <span key={label} style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 10, color: '#555' }}>
                            <span style={{ width: 8, height: 8, borderRadius: 2, background: color, display: 'inline-block' }} />
                            {label}
                          </span>
                        ))}
                      </div>
                    </div>
                    );
                  })()}

                  {/* ════════════════════════════════════════════════
                      CARD / KANBAN VIEW
                  ════════════════════════════════════════════════ */}
                  {viewMode === "card" && (
                    <div className="appt2-card-view" style={{ overflowX: "auto" }}>

                      {/* Status Filter Buttons for Card View */}
                      <div className="d-flex align-items-center justify-content-between gap-2 px-3 py-2 appt2-card-toolbar" style={{ borderBottom: "1px solid #f0f0f0", background: "#fff" }}>
                        <div className="d-flex align-items-center gap-2">
                        {(() => {
                          const allAppts = appointmentpatiemt.flatMap(doc => (doc.appointments || []).filter(a => a.status !== "Waiting"));
                          const allCount       = allAppts.length;
                          const completedCount = allAppts.filter(i => i.status?.toLowerCase() === "completed").length;
                          const pendingCount   = allCount - completedCount;
                          return [
                            { key: "all",       label: "All",       count: allCount       },
                            { key: "pending",   label: "Pending",   count: pendingCount   },
                            { key: "completed", label: "Completed", count: completedCount },
                          ];
                        })().map(({ key, label, count }) => (
                          <button
                            key={key}
                            onClick={() => { setStatusFilter(key); setCurrentPage(1); }}
                            style={{
                              padding: "6px 18px",
                              borderRadius: "20px",
                              fontSize: "13px",
                              fontWeight: statusFilter === key ? "600" : "400",
                              border: statusFilter === key ? "none" : "1px solid #dee2e6",
                              background: statusFilter === key
                                ? key === "completed" ? "#d4edda"
                                  : key === "pending"   ? "#fff3cd"
                                  : "#4680ff"
                                : "#fff",
                              color: statusFilter === key
                                ? key === "completed" ? "#155724"
                                  : key === "pending"   ? "#856404"
                                  : "#fff"
                                : "#6c757d",
                              cursor: "pointer",
                              transition: "all 0.2s ease",
                              boxShadow: statusFilter === key ? "0 2px 6px rgba(0,0,0,0.12)" : "none",
                            }}
                          >
                            {label} <span style={{ opacity: 0.75, fontWeight: "400" }}>({count})</span>
                          </button>
                        ))}
                        </div>

                        {/* Branch Filter */}
                        {allBranchSettings && allBranchSettings.length > 1 && (
                          <select
                            value={branchFilter}
                            onChange={e => { setBranchFilter(e.target.value); setCurrentPage(1); }}
                            style={{
                              height: 34, borderRadius: 8, border: "1px solid #dee2e6",
                              padding: "0 10px", fontSize: 13,
                              color: branchFilter !== "all" ? "#4680ff" : "#6c757d",
                              fontWeight: branchFilter !== "all" ? 600 : 400,
                              background: "#fff", cursor: "pointer", outline: "none", minWidth: 140,
                            }}
                          >
                            <option value="all">All Branches</option>
                            {allBranchSettings.map((b, i) => (
                              <option key={b.id} value={String(b.id)}>
                                Branch {i + 1}{b.official_name ? ` — ${b.official_name}` : ""}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>

                      {/* Sticky doctor header bar */}
                      <div className="appt2-doctor-header" style={{
                        display: "flex",
                        position: "sticky",
                        top: 0,
                        zIndex: 20,
                        background: "#f4f6fb",
borderBottom: "2px solid #e2e6f0",
borderTop: "1px solid #e2e6f0",
borderLeft: "1px solid #e2e6f0",
borderRight: "1px solid #e2e6f0",
borderRadius: "10px 10px 0 0",
                        minWidth: `${Math.max(appointmentpatiemt.length * 220, 300)}px`,
                        width: "100%",
                      }}>
                        {appointmentpatiemt.length === 0 ? (
                          <div style={{ padding: "14px 20px", color: "#9aa0ac", fontSize: "14px" }}>
                            No doctors found for the selected filter.
                          </div>
                        ) : (
                          appointmentpatiemt.map((doc, i) => {
                            if (!doc?.displayName) return null;
                            const name = doc.displayName.trim().replace(/\b\w/g, c => c.toUpperCase());
                            const apptCount = (doc.appointments || [])
                              .filter(a => a.status !== "Waiting")
                              .filter(a => {
                                if (statusFilter === "completed") return a.status?.toLowerCase() === "completed";
                                if (statusFilter === "pending") return a.status?.toLowerCase() !== "completed";
                                return true;
                              })
                              .filter(a => !(allBranchSettings && allBranchSettings.length > 1) || branchFilter === "all" || String(a.branch_id) === branchFilter)
                              .length;
                            return (
                              <div key={i} className="appt2-doctor-col" style={{
                                flex: "1 0 220px",
                                minWidth: 0,
                                boxSizing: "border-box",
                                padding: "12px 14px",
                                textAlign: "center",
                                borderRight: i < appointmentpatiemt.length - 1 ? "1px solid #e9ecef" : "none",
                              }}>
                                <div
                                  onClick={() => openDoctorWeekModal(doc)}
                                  title="View weekly schedule"
                                  style={{ fontWeight: "700", fontSize: "13.5px", color: "#1a1f36", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 5, maxWidth: "100%" }}
                                  onMouseEnter={e => e.currentTarget.style.color = "#2CA87F"}
                                  onMouseLeave={e => e.currentTarget.style.color = "#1a1f36"}
                                >
                                  <span style={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{name}</span>
                                  <i className="ti ti-calendar-week" style={{ fontSize: 13, opacity: 0.6, flexShrink: 0 }} />
                                </div>
                                <div style={{ fontSize: "11px", color: "#9aa0ac", marginTop: "2px" }}>
                                  {apptCount} appointment{apptCount !== 1 ? "s" : ""}
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>

                      {/* Appointment columns */}
                      <div className="appt2-doctor-columns" style={{
                        display: "flex",
                        alignItems: "flex-start",
                        minWidth: `${Math.max(appointmentpatiemt.length * 220, 300)}px`,
                        width: "100%",
                       background: "#f7f8fc",
minHeight: "400px",
padding: "12px 0",
border: "1px solid #e2e6f0",
borderTop: "none",
borderRadius: "0 0 10px 10px",
                      }}>
                        {appointmentpatiemt.map((doc, colIdx) => {
                          if (!doc?.displayName) return null;

                          // Sort appointments oldest → newest by startTime
                          const sorted = [...(doc.appointments || [])]
                            .filter(a => a.status !== "Waiting")
                            .filter(a => {
                              if (statusFilter === "completed") return a.status?.toLowerCase() === "completed";
                              if (statusFilter === "pending") return a.status?.toLowerCase() !== "completed";
                              return true;
                            })
                            .filter(a => branchFilter === "all" || String(a.branch_id) === branchFilter)
                            .sort((a, b) => {
                              const toMins = t => {
                                if (!t) return 0;
                                const [h, m] = t.split(":").map(Number);
                                return h * 60 + m;
                              };
                              return toMins(a.startTime) - toMins(b.startTime);
                            });

                          const statusStyle = {
                            "Completed":  { bg: "#d4edda", color: "#155724" },
                            "Cancelled":  { bg: "#f8d7da", color: "#721c24" },
                            "Emergency":  { bg: "#f5bebe", color: "#c0392b" },
                            "Booked":     { bg: "#cce5ff", color: "#004085" },
                            "Waiting":    { bg: "#fff3cd", color: "#856404" },
                            "Confirmed":  { bg: "#d1ecf1", color: "#0c5460" },
                            "No-show":    { bg: "#e2e3e5", color: "#383d41" },
                          };

                          return (
                            <div key={colIdx} className="appt2-doctor-col" style={{
                              flex: "1 0 220px",
                              minWidth: 0,
                              boxSizing: "border-box",
                              borderRight: colIdx < appointmentpatiemt.length - 1 ? "1px solid #e2e6ea" : "none",
                              padding: "0 10px",
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}>
                              {sorted.length === 0 ? (
                                <div style={{
                                  marginTop: "20px",
                                  textAlign: "center",
                                  color: "#c0c7d0",
                                  fontSize: "13px",
                                  padding: "24px 8px",
                                  border: "2px dashed #e2e6ea",
                                  borderRadius: "10px",
                                  background: "#fff",
                                }}>
                                  No appointments
                                </div>
                              ) : (
                                sorted.map((app, cardIdx) => {
                                  const sStyle = statusStyle[app.status] || { bg: "#f0f0f0", color: "#555" };

                                  // Format time
                                  const fmtTime = t => {
                                    if (!t) return "—";
                                    const d = new Date(`1970-01-01T${t}`);
                                    return d.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true });
                                  };

                                  // Duration in minutes
                                  const duration = (() => {
                                    if (!app.startTime || !app.endTime) return null;
                                    const [sh, sm] = app.startTime.split(":").map(Number);
                                    const [eh, em] = app.endTime.split(":").map(Number);
                                    return (eh * 60 + em) - (sh * 60 + sm);
                                  })();

                                  const name = app.patientName || app.onlinePatientName || "—";
                                  const photo = app.profileImage
                                    ? `${baseurImage}${app.profileImage}`
                                    : "/assets/images/user/avatar-1.jpg";
                                  const isCalled = calledIds.has(app.id) && app.status?.toLowerCase() !== "completed";
                                  const isArrived = arrivedIds.has(app.id) && app.status?.toLowerCase() !== "completed";
                                  const isCancelled = app.status?.toLowerCase() === "cancelled";

                                  // Due-or-overdue: scheduled start time has arrived/passed and it's still
                                  // pending (not already resolved) - flagged amber in the time text below.
                                  const isPastOrNow = (() => {
                                    if (!app.startTime) return false;
                                    const st = app.status?.toLowerCase();
                                    if (st === "completed" || st === "cancelled" || st === "no-show") return false;
                                    const apptDateStr = app.appointmentDate
                                      ? dayjs(app.appointmentDate).format("YYYY-MM-DD")
                                      : selectedDate
                                        ? selectedDate.format("YYYY-MM-DD")
                                        : dayjs().format("YYYY-MM-DD");
                                    const apptDateTime = dayjs(`${apptDateStr} ${app.startTime.slice(0, 5)}`, "YYYY-MM-DD HH:mm");
                                    return apptDateTime.isValid() && !apptDateTime.isAfter(dayjs());
                                  })();

                                  return (
                                    <div
                                      key={cardIdx}
                                      className="appt2-appt-card"
                                      onClick={() => Openmodalfunction(app)}
                                      style={{
                                        background: isCancelled
                                          ? "repeating-linear-gradient(135deg, #f1f2f4 0px, #f1f2f4 10px, #e6e8eb 10px, #e6e8eb 20px)"
                                          : isCalled ? "#fffbea" : "#fff",
                                        borderRadius: "12px",
                                        padding: "12px",
                                        boxShadow: isCalled
                                          ? "0 2px 10px rgba(251,140,0,0.30)"
                                          : "0 1px 6px rgba(0,0,0,0.08)",
                                        border: isCancelled ? "1px dashed #9aa0ac" : isCalled ? "1px solid #fbc02d" : "1px solid #edf0f7",
                                        cursor: "pointer",
                                        transition: "box-shadow 0.15s, transform 0.15s",
                                        borderLeft: isCancelled ? "4px solid #e74c3c" : isCalled ? "4px solid #fb8c00" : `4px solid ${sStyle.color}`,
                                        position: "relative",
                                        minWidth: 0,
                                        width: "100%",
                                        boxSizing: "border-box",
                                        overflow: "hidden",
                                        opacity: isCancelled ? 0.72 : 1,
                                        filter: isCancelled ? "grayscale(0.35)" : "none",
                                      }}
                                      onMouseEnter={e => {
                                        e.currentTarget.style.boxShadow = isCalled
                                          ? "0 4px 16px rgba(251,140,0,0.40)"
                                          : "0 4px 16px rgba(0,0,0,0.13)";
                                        e.currentTarget.style.transform = "translateY(-1px)";
                                      }}
                                      onMouseLeave={e => {
                                        e.currentTarget.style.boxShadow = isCalled
                                          ? "0 2px 10px rgba(251,140,0,0.30)"
                                          : "0 1px 6px rgba(0,0,0,0.08)";
                                        e.currentTarget.style.transform = "";
                                      }}
                                    >
                                      {/* Top row: photo + name + status */}
                                      <div style={{ display: "flex", alignItems: "center", gap: "9px", marginBottom: "9px" }}>
                                        <img
                                          src={photo}
                                          alt=""
                                          style={{
                                            width: "38px",
                                            height: "38px",
                                            borderRadius: "8px",
                                            objectFit: "cover",
                                            flexShrink: 0,
                                            border: "1px solid #e9ecef",
                                          }}
                                        />
                                        <div style={{ flex: 1, minWidth: 0 }}>
                                          <div style={{
                                            fontWeight: "600",
                                            fontSize: "13px",
                                            color: "#1a1f36",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}>
                                            {name}
                                          </div>
                                          {(app.age || app.gender) && (
                                            <div style={{ fontSize: "11px", color: "#9aa0ac", marginTop: "1px" }}>
                                              {[app.age ? `${app.age} yrs` : null, app.gender].filter(Boolean).join(" · ")}
                                            </div>
                                          )}
                                        </div>
                                        <span style={{
                                          fontSize: "10px",
                                          fontWeight: "600",
                                          padding: "2px 7px",
                                          borderRadius: "20px",
                                          background: sStyle.bg,
                                          color: sStyle.color,
                                          whiteSpace: "nowrap",
                                          flexShrink: 0,
                                        }}>
                                          {app.status || "—"}
                                        </span>
                                      </div>

                                      {/* Called / Arrived indicators */}
                                      {(isCalled || isArrived) && (
                                        <div style={{ display: "flex", alignItems: "center", gap: 5, marginBottom: "6px", flexWrap: "wrap" }}>
                                          {isArrived && (
                                            <ArrivedBadge arrivalTime={arrivalTimes[app.id]} freezeAt={callTimes[app.id]} />
                                          )}
                                          {isCalled && (
                                            <span style={{
                                              fontSize: 10, fontWeight: 700, padding: "2px 8px", borderRadius: 20,
                                              background: "#fb8c00", color: "#fff", letterSpacing: "0.04em",
                                            }}>
                                              <i className="ti ti-speakerphone me-1" style={{ fontSize: 10 }} />CALLED
                                            </span>
                                          )}
                                        </div>
                                      )}

                                      {/* Divider */}
                                      <div style={{ height: "1px", background: "#f0f2f5", marginBottom: "8px" }} />

                                      {/* Time + duration */}
                                      <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "5px" }}>
                                        <i className="ti ti-clock" style={{ fontSize: "13px", color: isPastOrNow ? "#b84f4f" : "#4680ff" }} />
                                        <span style={{ fontSize: "12px", color: isPastOrNow ? "#b84f4f" : "#495057", fontWeight: "600" }}>
                                          {fmtTime(app.startTime)}
                                          {app.endTime && ` – ${fmtTime(app.endTime)}`}
                                        </span>
                                        {duration !== null && duration > 0 && (
                                          <span style={{
                                            fontSize: "10px",
                                            background: "#f0f4ff",
                                            color: "#4680ff",
                                            borderRadius: "10px",
                                            padding: "1px 7px",
                                            fontWeight: "600",
                                          }}>
                                            {duration} min
                                          </span>
                                        )}
                                      </div>

                                      {/* Reason */}
                                      {app.reason && (
                                        <div style={{ display: "flex", alignItems: "flex-start", gap: "6px" }}>
                                          <i className="ti ti-notes" style={{ fontSize: "12px", color: "#9aa0ac", marginTop: "2px", flexShrink: 0 }} />
                                          <span style={{
                                            fontSize: "11.5px",
                                            color: "#6c757d",
                                            display: "-webkit-box",
                                            WebkitLineClamp: 2,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            lineHeight: "1.4",
                                            flex: 1,
                                            minWidth: 0,
                                            wordBreak: "break-word",
                                          }}>
                                            {app.reason}
                                          </span>
                                        </div>
                                      )}

                                      {/* Insurance indicator */}
                                      {app.hasInsurance == 1 && (
                                        <div
                                          title="Active Insurance"
                                          style={{
                                            position: "absolute",
                                            bottom: 8,
                                            right: 8,
                                            width: 20,
                                            height: 20,
                                            borderRadius: "50%",
                                            background: "#fff8dc",
                                            border: "1.5px solid #f5c518",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                          }}
                                        >
                                          <i className="ti ti-shield-check" style={{ fontSize: 11, color: "#e6a800" }} />
                                        </div>
                                      )}
                                    </div>
                                  );
                                })
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}

                </div>
              </div>
            )}
          </div>
        </div>
        {hoverAppointment && (
          <div
            style={{
              position: "fixed",
              top: hoverPosition.top,
              left: hoverPosition.left,
              width: 300,
              maxHeight: 400,
              overflowY: "auto",
              background: "#fff",
              borderRadius: 10,
              border: "1px solid #e2e6ea",
              boxShadow: "0 8px 28px rgba(0,0,0,0.18)",
              zIndex: 10000,
              padding: "12px 14px",
              pointerEvents: "none",
              fontSize: 12,
              color: "#374151",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 8 }}>
              <img
                src={hoverAppointment?.profileImage ? `${baseurImage}${hoverAppointment.profileImage}` : "/assets/images/user/avatar-1.jpg"}
                alt=""
                style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover", flexShrink: 0 }}
              />
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 700, fontSize: 13, color: "#1a202c", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {hoverAppointment?.patientName || hoverAppointment?.onlinePatientName || "-"}
                </div>
                {hoverAppointment?.patientId > 0 && (
                  <div style={{ color: "#5B6B79", fontSize: 11 }}>
                    {hoverAppointment?.age ? `${hoverAppointment.age} yrs` : ""}{hoverAppointment?.age && hoverAppointment?.gender ? " · " : ""}{hoverAppointment?.gender || ""}
                  </div>
                )}
              </div>
            </div>

            {hoverAppointment?.patientId > 0 && hoverAppointment?.mobileNumber && (
              <p style={{ margin: "2px 0" }}><strong>Phone:</strong> {hoverAppointment.mobileNumber}</p>
            )}
            <p style={{ margin: "2px 0" }}><strong>Doctor:</strong> {hoverAppointment?.displayName || "-"}</p>

            {hoverAppointment?.hasInsurance == 1 && (
              <div style={{
                display: "inline-flex", alignItems: "center", gap: 5,
                background: "#fff8dc", border: "1px solid #f5c518",
                borderRadius: 16, padding: "2px 8px", margin: "3px 0",
              }}>
                <i className="ti ti-shield-check" style={{ fontSize: 11, color: "#e6a800" }} />
                <span style={{ fontSize: 11, fontWeight: 600, color: "#7a5900" }}>
                  {hoverAppointment?.insuranceCompanyName || "Active Insurance"}
                </span>
              </div>
            )}

            <p style={{ margin: "2px 0" }}>
              <strong>Date:</strong>{" "}
              {hoverAppointment?.appointmentDate ? new Date(hoverAppointment.appointmentDate).toLocaleDateString("en-GB") : "-"}
            </p>
            <p style={{ margin: "2px 0" }}>
              <strong>Time:</strong>{" "}
              {hoverAppointment?.startTime
                ? new Date(`1970-01-01T${hoverAppointment.startTime}`).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
                : ""}{" "}
              -{" "}
              {hoverAppointment?.endTime
                ? new Date(`1970-01-01T${hoverAppointment.endTime}`).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
                : ""}
            </p>
            <p style={{ margin: "2px 0" }}><strong>Duration:</strong> {hoverAppointment?.duration || "-"}</p>
            <p style={{ margin: "2px 0" }}><strong>Status:</strong> {hoverAppointment?.status || "-"}</p>

            {(hoverAppointment?.status === "Booked" || hoverAppointment?.status === "Confirmed") && hoverNoShowRisk && (
              <p style={{ margin: "2px 0" }}>
                <strong>No-show Risk:</strong>{" "}
                <span style={{
                  display: "inline-block",
                  padding: "2px 8px",
                  borderRadius: 6,
                  fontSize: 11,
                  fontWeight: 600,
                  opacity: hoverNoShowRisk.confidence === "low" ? 0.6 : 1,
                  ...(riskBadgeConfig[hoverNoShowRisk.bucket] || riskBadgeConfig.low),
                }}>
                  {riskBadgeConfig[hoverNoShowRisk.bucket]?.label || "Low"}
                </span>
              </p>
            )}

            {hoverAppointment?.reason && (
              <p style={{ margin: "2px 0" }}><strong>Reason:</strong> {hoverAppointment.reason}</p>
            )}

            {(hoverWaitingRecord?.arrival_time || hoverWaitingRecord?.call_time || hoverWaitingRecord?.finish_time) && (
              <div style={{ marginTop: 6, paddingTop: 6, borderTop: "1px solid #edf0f7" }}>
                <div style={{ fontWeight: 700, marginBottom: 3, color: "#1a202c" }}>Waiting Tracker</div>
                {hoverWaitingRecord?.arrival_time && (
                  <div>Arrived: {new Date(hoverWaitingRecord.arrival_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}</div>
                )}
                {hoverWaitingRecord?.call_time && (
                  <div>Called: {new Date(hoverWaitingRecord.call_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}</div>
                )}
                {hoverWaitingRecord?.finish_time && (
                  <div>Finished: {new Date(hoverWaitingRecord.finish_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}</div>
                )}
              </div>
            )}
          </div>
        )}
        {showCalendarModal && (
          <div
            className="modal fade show"
            style={{
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "block",
            }}
            onClick={closeCalendarModal}
          >
            <div
              className="modal-dialog modal-lg"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Appointment Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeCalendarModal}
                  ></button>
                </div>
                <div className="modal-body appointmentDetails">
                  <div className="d-flex justify-content-between">
                    <div className="parentDetailApp">
                      <div className="appDeailsImg">
                        {datamodalappointment?.patientId > 0 ? (
                          <NavLink
                            to="/Admin/Manageappointment"
                            state={{
                              patientid: {
                                ...datamodalappointment,
                                id: datamodalappointment.patientId,
                              },
                            }}
                          >
                            <img
                              src={`${baseurImage}${datamodalappointment?.profileImage}`}
                              alt=""
                            />
                          </NavLink>
                        ) : (
                          <img
                            src={datamodalappointment?.profileImage ? `${baseurImage}${datamodalappointment.profileImage}` : "/assets/images/user/avatar-1.jpg"}
                            alt=""
                            style={{ cursor: "default" }}
                          />
                        )}
                      </div>
                      <div>
                        <p>
                          <strong>Patient Name : </strong>{" "}
                          {datamodalappointment?.patientName || datamodalappointment?.onlinePatientName || "-"}
                        </p>
                        {datamodalappointment?.patientId > 0 && (
                          <>
                            <div className="d-flex ms-0">
                              <p className="me-4">
                                <strong>Age :</strong>
                                {datamodalappointment?.age}
                              </p>
                              <p>
                                <strong>Gender :</strong>
                                {datamodalappointment?.gender}
                              </p>
                            </div>
                            <p>
                              <strong>Phone :</strong>
                              {datamodalappointment?.mobileNumber}
                            </p>
                          </>
                        )}
                        <p>
                          <strong>Doctor Name :</strong>{" "}
                          {datamodalappointment?.displayName}
                        </p>
                        {datamodalappointment?.hasInsurance == 1 && (
                          <div style={{
                            display: "inline-flex", alignItems: "center", gap: 6,
                            background: "#fff8dc", border: "1.5px solid #f5c518",
                            borderRadius: 20, padding: "3px 10px", marginTop: 4,
                          }}>
                            <i className="ti ti-shield-check" style={{ fontSize: 13, color: "#e6a800" }} />
                            <span style={{ fontSize: 12, fontWeight: 600, color: "#7a5900" }}>
                              {datamodalappointment?.insuranceCompanyName || "Active Insurance"}
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                    {datamodalappointment?.patientId > 0 && (
                      <div className="d-flex iconTab">
                        <i
                          className="ti ti-edit f-20"
                          style={{ cursor: "pointer" }}
                          onClick={() => handledopencllick(datamodalappointment)}
                        ></i>
                        <i
                          className="ti ti-mail f-20"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSendEmail(datamodalappointment)}
                          title="Send Email Notification"
                        ></i>
                        <i
                          className="ti ti-message f-20"
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            sendAppointmentSMS(datamodalappointment?.id)
                          }
                          title="Send SMS Notification"
                        ></i>
                        <i
                          className="ti ti-brand-whatsapp f-20"
                          style={{ cursor: "pointer", color: "#25D366", border: "1px solid #25D366" }}
                          onClick={() =>
                            sendAppointmentWhatsApp(datamodalappointment?.id)
                          }
                          title="Send WhatsApp Notification"
                        ></i>
                      </div>
                    )}
                  </div>
                  <div className="patientApp mt-4">
                    <p>
                      <strong>Date :</strong>{" "}
                      {new Date(
                        datamodalappointment?.appointmentDate
                      ).toLocaleDateString("en-GB")}
                    </p>
                    <p>
                      <strong>Appointment Time :</strong>{" "}
                      {datamodalappointment?.startTime
                        ? new Date(
                          `1970-01-01T${datamodalappointment?.startTime}`
                        ).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : ""}{" "}
                      -{" "}
                      {datamodalappointment?.endTime
                        ? new Date(
                          `1970-01-01T${datamodalappointment?.endTime}`
                        ).toLocaleTimeString("en-US", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        })
                        : ""}
                    </p>
                    <p>
                      <strong>Duration :</strong>{" "}
                      {datamodalappointment?.duration}
                    </p>
                    <p>
                      <strong>Status :</strong>
                      {datamodalappointment?.status}
                    </p>
                    {(datamodalappointment?.status === "Booked" || datamodalappointment?.status === "Confirmed") && modalNoShowRisk && (
                      <p>
                        <strong>No-show Risk :</strong>{" "}
                        <span
                          title="Automatically generated by a rule-based prediction model — not a clinical or human judgment"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 3,
                            padding: "1px 6px",
                            borderRadius: 10,
                            fontSize: 10,
                            fontWeight: 700,
                            letterSpacing: "0.03em",
                            background: "#eef2ff",
                            color: "#4338ca",
                            marginRight: 6,
                            verticalAlign: "middle",
                          }}
                        >
                          <i className="ti ti-brain" style={{ fontSize: 11 }} />
                          AI
                        </span>
                        <span
                          title={modalNoShowRisk.reasons?.join(" | ")}
                          style={{
                            display: "inline-block",
                            padding: "3px 10px",
                            borderRadius: "6px",
                            fontSize: 12,
                            fontWeight: 500,
                            opacity: modalNoShowRisk.confidence === "low" ? 0.6 : 1,
                            cursor: "default",
                            ...(riskBadgeConfig[modalNoShowRisk.bucket] || riskBadgeConfig.low),
                          }}
                        >
                          {riskBadgeConfig[modalNoShowRisk.bucket]?.label || "Low"}
                          {modalNoShowRisk.confidence === "low" ? " (new patient / limited data)" : ""}
                        </span>
                        {modalNoShowRisk.reasons?.length > 0 && (
                          <span style={{ display: "block", fontSize: 11, color: "#5B6B79", marginTop: 4 }}>
                            {modalNoShowRisk.reasons.join(" · ")}
                          </span>
                        )}
                      </p>
                    )}
                    <p>
                      <strong>Reason :</strong>
                      {datamodalappointment?.reason}
                    </p>
                  </div>

                  {/* Waiting Tracker */}
                  <div className="mt-3 pt-3" style={{ borderTop: "1px solid #e8ecf0" }}>
                    <p className="mb-2"><strong>Waiting Tracker</strong></p>
                    <div className="d-flex gap-2 flex-wrap align-items-center">

                      {waitingRecord?.arrival_time ? (
                        <span className="badge bg-success" style={{ fontSize: 12, padding: "5px 10px" }}>
                          <i className="ti ti-check me-1" />
                          Arrived: {new Date(waitingRecord.arrival_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}
                        </span>
                      ) : (
                        <button className="borderBtn" style={{ fontSize: "12px", padding: "4px 12px" }} onClick={handleArrived} title="Patient arrived to waiting area">
                          <i className="ti ti-door-enter me-1" />Arrived
                        </button>
                      )}

                      {waitingRecord?.call_time ? (
                        <span className="badge bg-primary" style={{ fontSize: 12, padding: "5px 10px" }}>
                          <i className="ti ti-speakerphone me-1" />
                          Called: {new Date(waitingRecord.call_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}
                        </span>
                      ) : (
                        <button
                          className="bgBtn"
                          style={{ fontSize: "12px", padding: "4px 12px" }}
                          onClick={handleCall}
                          disabled={!waitingRecord?.arrival_time}
                          title={!waitingRecord?.arrival_time ? "Mark patient as Arrived first" : undefined}
                        >
                          <i className="ti ti-speakerphone me-1" />Call
                        </button>
                      )}

                      {waitingRecord?.finish_time && (
                        <span className="badge bg-secondary" style={{ fontSize: 12, padding: "5px 10px" }}>
                          Finished: {new Date(waitingRecord.finish_time).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })}
                        </span>
                      )}

                    </div>
                  </div>

                </div>
                {datamodalappointment?.status === "Completed" ? null : (
                  <div className="modal-footer d-flex justify-content-end mt-3" style={{ gap: "6px" }}>
                    {datamodalappointment?.status === "Cancelled" ? null : (
                      <button
                        className="cancelBtn"
                        style={{ fontSize: "12px", padding: "4px 12px" }}
                        onClick={() =>
                          handleclickcancleapoointment(datamodalappointment)
                        }
                      >
                        Cancelled
                      </button>
                    )}

                    {datamodalappointment?.status === "Confirmed" ? null : (
                      <button
                        className="borderBtn"
                        style={{ fontSize: "12px", padding: "4px 12px" }}
                        onClick={() =>
                          handleupdateconfirm(datamodalappointment)
                        }
                      >
                        Confirmed
                      </button>
                    )}

                    <button
                      className="bgBtn"
                      style={{ fontSize: "12px", padding: "4px 12px", background: "#28a745", borderColor: "#28a745" }}
                      onClick={async () => {
                        try {
                          const response = await axiosInstance.post(
                            `changeAppointmentStatus/${datamodalappointment.id}`,
                            { status: "Completed" }
                          );
                          if (response.data.success === true) {
                            const userid11 = JSON.parse(localStorage.getItem("userarray"));
                            const freshDoctorIds = userid11?.data || [];
                            if (freshDoctorIds.length > 0) {
                              const sDate = selectedDate ? selectedDate.format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
                              await syncFiltersAndFetch(sDate, sDate, freshDoctorIds, 'single');
                            }
                            closeCalendarModal();
                            Swal.fire("Success", "Appointment marked as Completed", "success");
                          }
                        } catch (error) {
                          console.error("Error:", error.message);
                        }
                      }}
                    >
                      Completed
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {modalopen && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e8ecf0', width: '100%', maxWidth: 680, maxHeight: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>

              {/* Header */}
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: '#f39c1215', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="ti ti-clock" style={{ color: '#f39c12', fontSize: 17 }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>Walk-in List</div>
                  <div style={{ fontSize: 11, color: '#5B6B79' }}>Walk-in patients waiting to be scheduled</div>
                </div>
                <div style={{ position: 'relative' }}>
                  <i className="ti ti-search" style={{ position: 'absolute', left: 9, top: '50%', transform: 'translateY(-50%)', color: '#9CA3AF', fontSize: 13, pointerEvents: 'none' }} />
                  <input
                    placeholder="Search patient…"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value.toLowerCase())}
                    style={{ height: 32, fontSize: 12, border: '1px solid #d0d5dd', borderRadius: 8, paddingLeft: 28, paddingRight: 10, outline: 'none', width: 190, color: '#374151' }}
                  />
                </div>
                <button
                  onClick={handleclose}
                  style={{ width: 28, height: 28, borderRadius: 7, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0 }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#dc2626'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79'; }}
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              {/* Body */}
              <div style={{ flex: 1, overflowY: 'auto', padding: '0 4px' }}>
                {filteredData && filteredData.length > 0 ? (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f8f9fb', borderBottom: '1px solid #e8ecf0' }}>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left', width: 40 }}>#</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left' }}>Patient</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left' }}>Doctor</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left' }}>Date</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredData.map((item, index) => (
                        <tr key={item.id || index} style={{ borderBottom: '1px solid #f0f2f5' }}
                          onMouseEnter={e => e.currentTarget.style.background = '#fafbfc'}
                          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                        >
                          <td style={{ padding: '10px 16px', fontSize: 12, color: '#9CA3AF', textAlign: 'center' }}>{index + 1}</td>
                          <td style={{ padding: '10px 16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                              <div style={{ width: 28, height: 28, borderRadius: 7, background: '#2CA87F15', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                <i className="ti ti-user" style={{ fontSize: 13, color: '#2CA87F' }} />
                              </div>
                              {item.patientId && item.patientId !== 0 ? (
                                <NavLink to="/Admin/Manageappointment" state={{ patientid: { ...item, id: item.patientId || item.patient_id } }}
                                  style={{ textDecoration: 'none', fontSize: 13, fontWeight: 600, color: '#1a202c' }}>
                                  {item.patientName}
                                </NavLink>
                              ) : (
                                <span style={{ fontSize: 13, fontWeight: 600, color: '#1a202c' }}>{item.onlinePatientName || '—'}</span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '10px 16px' }}>
                            {item.doctorName
                              ? <span style={{ fontSize: 12, color: '#374151', background: '#f0faf6', border: '1px solid #b7e4cf', borderRadius: 5, padding: '2px 8px', fontWeight: 500 }}>{item.doctorName}</span>
                              : <span style={{ color: '#d1d5db', fontSize: 12 }}>—</span>}
                          </td>
                          <td style={{ padding: '10px 16px', fontSize: 12, color: '#374151', whiteSpace: 'nowrap' }}>
                            <i className="ti ti-calendar" style={{ marginRight: 4, color: '#9CA3AF', fontSize: 11 }} />
                            {item.appointmentDate ? new Date(item.appointmentDate).toLocaleDateString('en-GB') : '—'}
                          </td>
                          <td style={{ padding: '10px 16px' }}>
                            <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                              <button
                                onClick={() => handleclick(item.id, item)}
                                style={{ padding: '5px 14px', borderRadius: 7, border: '1.5px solid #2CA87F', background: '#2CA87F', color: '#fff', cursor: 'pointer', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4, transition: 'all 0.15s' }}
                                onMouseEnter={e => { e.currentTarget.style.background = '#228f6b'; e.currentTarget.style.borderColor = '#228f6b'; }}
                                onMouseLeave={e => { e.currentTarget.style.background = '#2CA87F'; e.currentTarget.style.borderColor = '#2CA87F'; }}
                              >
                                <i className="ti ti-calendar-check" style={{ fontSize: 13 }} /> Book
                              </button>
                              <button
                                onClick={() => handledelet(item.id)}
                                style={{ padding: '5px 12px', borderRadius: 7, border: '1.5px solid #e74c3c', background: 'transparent', color: '#e74c3c', cursor: 'pointer', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4, transition: 'all 0.15s' }}
                                onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; }}
                                onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                              >
                                <i className="ti ti-x" style={{ fontSize: 13 }} /> Cancel
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ padding: '48px 0', textAlign: 'center' }}>
                    <div style={{ width: 48, height: 48, borderRadius: 12, background: '#f8f9fb', border: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                      <i className="ti ti-clock-off" style={{ fontSize: 22, color: '#d1d5db' }} />
                    </div>
                    <div style={{ fontSize: 13, color: '#9CA3AF', fontWeight: 500 }}>No walk-in patients found</div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div style={{ padding: '12px 20px', borderTop: '1px solid #e8ecf0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0, background: '#fafbfc', borderRadius: '0 0 14px 14px' }}>
                <span style={{ fontSize: 12, color: '#9CA3AF' }}>
                  {filteredData?.length || 0} walk-in patient{filteredData?.length !== 1 ? 's' : ''} waiting
                </span>
              </div>
            </div>
          </div>
        )}

        {waitingRoomOpen && (
          <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e8ecf0', width: '60vw', maxWidth: '60vw', maxHeight: '88vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 40px rgba(0,0,0,0.18)' }}>

              {/* Header */}
              <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                <div style={{ width: 32, height: 32, borderRadius: 8, background: '#2CA87F15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <i className="ti ti-hourglass" style={{ color: '#2CA87F', fontSize: 17 }} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>Waiting Room</div>
                  <div style={{ fontSize: 11, color: '#5B6B79' }}>Patients who have arrived and are waiting to be seen</div>
                </div>
                <button
                  onClick={() => setWaitingRoomOpen(false)}
                  style={{ width: 28, height: 28, borderRadius: 7, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0 }}
                  onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#dc2626'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79'; }}
                >
                  <i className="ti ti-x" />
                </button>
              </div>

              {/* Body */}
              <div style={{ flex: 1, overflowY: 'auto', padding: '0 4px' }}>
                {waitingRoomList.length > 0 ? (
                  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr style={{ background: '#f8f9fb', borderBottom: '1px solid #e8ecf0' }}>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left', width: 40 }}>#</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left' }}>Patient</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left' }}>Doctor</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'left' }}>Waiting</th>
                        <th style={{ padding: '10px 16px', fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em', textAlign: 'center' }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {waitingRoomList.map((app, index) => {
                        const name = app.patientName || app.onlinePatientName || '—';
                        return (
                          <tr key={app.id || index} style={{ borderBottom: '1px solid #f0f2f5' }}
                            onMouseEnter={e => e.currentTarget.style.background = '#fafbfc'}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                          >
                            <td style={{ padding: '10px 16px', fontSize: 12, color: '#9CA3AF', textAlign: 'center' }}>{index + 1}</td>
                            <td style={{ padding: '10px 16px' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <div style={{ width: 28, height: 28, borderRadius: 7, background: '#2CA87F15', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                  <i className="ti ti-user" style={{ fontSize: 13, color: '#2CA87F' }} />
                                </div>
                                <span style={{ fontSize: 13, fontWeight: 600, color: '#1a202c' }}>{name}</span>
                              </div>
                            </td>
                            <td style={{ padding: '10px 16px' }}>
                              {app.doctorName
                                ? <span style={{ fontSize: 12, color: '#374151', background: '#f0faf6', border: '1px solid #b7e4cf', borderRadius: 5, padding: '2px 8px', fontWeight: 500 }}>{app.doctorName}</span>
                                : <span style={{ color: '#d1d5db', fontSize: 12 }}>—</span>}
                            </td>
                            <td style={{ padding: '10px 16px' }}>
                              <ArrivedBadge arrivalTime={app.arrival_time} />
                            </td>
                            <td style={{ padding: '10px 16px' }}>
                              <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                                <button
                                  onClick={() => handleCallFromWaitingRoom(app.id)}
                                  title="Call patient"
                                  style={{ padding: '5px 12px', borderRadius: 7, border: '1.5px solid #fb8c00', background: 'transparent', color: '#fb8c00', cursor: 'pointer', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4, transition: 'all 0.15s' }}
                                  onMouseEnter={e => { e.currentTarget.style.background = '#fff3e0'; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                                >
                                  <i className="ti ti-speakerphone" style={{ fontSize: 13 }} /> Call
                                </button>
                                <button
                                  onClick={() => { setWaitingRoomOpen(false); Openmodalfunction(app); }}
                                  style={{ padding: '5px 12px', borderRadius: 7, border: '1.5px solid #2CA87F', background: 'transparent', color: '#2CA87F', cursor: 'pointer', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4, transition: 'all 0.15s' }}
                                  onMouseEnter={e => { e.currentTarget.style.background = '#eafaf3'; }}
                                  onMouseLeave={e => { e.currentTarget.style.background = 'transparent'; }}
                                >
                                  <i className="ti ti-eye" style={{ fontSize: 13 }} /> Open
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : (
                  <div style={{ padding: '48px 0', textAlign: 'center' }}>
                    <div style={{ width: 48, height: 48, borderRadius: 12, background: '#f8f9fb', border: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
                      <i className="ti ti-hourglass-empty" style={{ fontSize: 22, color: '#d1d5db' }} />
                    </div>
                    <div style={{ fontSize: 13, color: '#9CA3AF', fontWeight: 500 }}>No patients in the waiting room</div>
                  </div>
                )}
              </div>

              {/* Footer */}
              <div style={{ padding: '12px 20px', borderTop: '1px solid #e8ecf0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0, background: '#fafbfc', borderRadius: '0 0 14px 14px' }}>
                <span style={{ fontSize: 12, color: '#9CA3AF' }}>
                  {waitingRoomList.length} patient{waitingRoomList.length !== 1 ? 's' : ''} waiting
                </span>
              </div>
            </div>
          </div>
        )}



        {/* ✅ NEW: Online Appointments Modal - Same style as Waiting List */}
        {/* ========== ONLINE APPOINTMENTS MODAL ========== */}
        {onlineModalOpen && (
          <div
            className="modal fade show"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">
                    Online Appointments

                  </h5>
                </div>
                <div className="modal-body">
                  <div className="mb-3 d-flex justify-content-end">
                    <input
                      className="searchInput"
                      placeholder="Search by name, email, phone..."
                      value={onlineSearchText}
                      onChange={(e) => setOnlineSearchText(e.target.value.toLowerCase())}
                    />
                  </div>
                  <div className="table-responsive table table-striped">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Sr. No.</th>
                          <th>Patient Name</th>
                          {/* <th>Email</th> */}
                          <th>Phone</th>
                          {/* <th>Service</th> */}
                          <th>Date</th>
                          {/* <th>Time</th> */}
                          {/* <th>Status</th> */}
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {onlineData && onlineData.length > 0 ? (
                          onlineData
                            .filter((item) =>
                              item?.appointmentFirstName?.toLowerCase().includes(onlineSearchText) ||
                              item?.appointmentLastName?.toLowerCase().includes(onlineSearchText) ||
                              item?.appointmentEmail?.toLowerCase().includes(onlineSearchText) ||
                              item?.appointmentPhoneNumber?.toLowerCase().includes(onlineSearchText) ||
                              item?.appointmentServiceName?.toLowerCase().includes(onlineSearchText)
                            )
                            .map((item, index) => (
                              <tr key={item.appointmentId || index}>
                                <td>{index + 1}</td>
                                <td>
                                  <strong>
                                    {item.appointmentFirstName} {item.appointmentLastName}
                                  </strong>
                                </td>
                                {/* <td>{item.appointmentEmail}</td> */}
                                <td>{item.appointmentPhoneNumber}</td>
                                {/* <td>
                                  {item.appointmentServiceName?.length > 25
                                    ? `${item.appointmentServiceName.slice(0, 25)}...`
                                    : item.appointmentServiceName}
                                </td> */}
                                <td>
                                  {item.appointmentDate
                                    ? new Date(item.appointmentDate).toLocaleDateString("en-GB")
                                    : "-"}
                                </td>
                                {/* <td>
                                  {item.appointmentStartTime && item.appointmentEndTime ? (
                                    <>
                                      {item.appointmentStartTime.slice(0, 5)} - {item.appointmentEndTime.slice(0, 5)}
                                    </>
                                  ) : (
                                    <span className="text-muted">Not Scheduled</span>
                                  )}
                                </td> */}
                                {/* <td>
                                  <span
                                    className="badge"
                                    style={{
                                      backgroundColor: item.appointmentStatus === "Pending" ? "#fff3cd" : "#d1ecf1",
                                      color: item.appointmentStatus === "Pending" ? "#856404" : "#0c5460",
                                      padding: "6px 10px",
                                      borderRadius: "4px",
                                      fontSize: "12px"
                                    }}
                                  >
                                    {item.appointmentStatus}
                                  </span>
                                </td> */}
                                <td className="text-center">
                                  <div className="d-flex justify-content-center">
                                    <div
                                      className="blueBadg me-2"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handleOnlineBookClick(item)}
                                      title="Move to Waiting List"
                                    >
                                      Book
                                    </div>
                                    <div
                                      className="dangerBadg"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => cancelOnlineAppointment(item.appointmentId)}
                                      title="Cancel Appointment"
                                    >
                                      Cancel
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan="9" className="text-center text-muted py-4">
                              No Online Appointments Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer">
                  <button onClick={handleCloseOnlineModal} className="cancelText">
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ NEW: Online Booking Confirmation Modal */}
        {onlineBookingModal && (
          <div
            className="modal fade show"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Online Booking</h5>
                </div>
                <div className="modal-body equalBorder">
                  {/* Row 1: Patient Info (Disabled) */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Patient Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedPatient ? selectedPatient.name : `${selectedOnlineAppointment?.appointmentFirstName || ''} ${selectedOnlineAppointment?.appointmentLastName || ''}`}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Service</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedOnlineAppointment?.appointmentServiceName || ''}
                        disabled
                      />
                    </div>
                  </div>

                  {/* Row 2: Contact Info (Disabled) */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">Email</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedOnlineAppointment?.appointmentEmail || ''}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Phone</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedOnlineAppointment?.appointmentPhoneNumber || ''}
                        disabled
                      />
                    </div>
                  </div>

                  <hr />

                  {/* Info Text */}
                  <div className="mb-3">
                    <small className="text-muted">
                      Original Requested Time: {selectedOnlineAppointment?.appointmentStartTime?.slice(0, 5) || '-'} - {selectedOnlineAppointment?.appointmentEndTime?.slice(0, 5) || '-'} on {selectedOnlineAppointment?.appointmentDate ? new Date(selectedOnlineAppointment.appointmentDate).toLocaleDateString('en-GB') : '-'}
                    </small>
                  </div>

                  {/* Row 3: Doctor & Date */}
                  <div className="row mb-3">
                    <div className="col-md-6">
                      <label className="form-label">
                        Doctor <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-select"
                        name="doctorId"
                        value={onlineBookingData.doctorId}
                        onChange={handleOnlineBookingChange}
                      >
                        <option value="">Select Doctor</option>
                        {doctorsdata?.map((doctor) => (
                          <option key={doctor.id} value={doctor.id}>
                            {doctor.displayName}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">
                        Date <span className="text-danger">*</span>
                      </label>
                      <input
                        type="date"
                        name="date"
                        className="form-control"
                        value={onlineBookingData.date}
                        onChange={handleOnlineBookingChange}
                      />
                    </div>
                  </div>

                  {/* Row 4: Time — slot picker if force_schedule enabled, else free inputs */}
                  {forceScheduleEnabled ? (
                    <div className="mb-2">
                      <label className="form-label">
                        Available Time Slots <span className="text-danger">*</span>
                      </label>
                      {scheduleLoading ? (
                        <div className="text-muted" style={{ padding: '10px 0' }}>Loading schedule...</div>
                      ) : isDayOff ? (
                        <div style={{ padding: '12px 16px', borderRadius: 8, background: '#fff3f3', border: '1px solid #f5c2c7', color: '#842029', fontWeight: 500 }}>
                          <i className="ti ti-calendar-off me-2" />Doctor is unavailable (day off)
                        </div>
                      ) : !onlineBookingData.doctorId || !onlineBookingData.date ? (
                        <div className="text-muted" style={{ padding: '10px 0' }}>Select a doctor and date to see available slots.</div>
                      ) : doctorScheduleSlots.length === 0 ? (
                        <div style={{ padding: '12px 16px', borderRadius: 8, background: '#fffbec', border: '1px solid #fde68a', color: '#92400e', fontWeight: 500 }}>
                          <i className="ti ti-calendar-x me-2" />No schedule found for this doctor on the selected date.
                        </div>
                      ) : (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginTop: 4 }}>
                          {doctorScheduleSlots.map((slot) => {
                            const slotStart = slot.start_time?.slice(0, 5);
                            const slotEnd = slot.end_time?.slice(0, 5);
                            const isSelected = onlineBookingData.startTime === slotStart && onlineBookingData.endTime === slotEnd;
                            return (
                              <button
                                key={slot.id}
                                type="button"
                                onClick={() => setOnlineBookingData(prev => ({ ...prev, startTime: slotStart, endTime: slotEnd }))}
                                style={{
                                  padding: '8px 18px',
                                  borderRadius: 8,
                                  border: isSelected ? '2px solid #2CA87F' : '1px solid #d0d5dd',
                                  background: isSelected ? '#e8f7f2' : '#fff',
                                  color: isSelected ? '#1a7a5c' : '#344054',
                                  fontWeight: isSelected ? 700 : 400,
                                  cursor: 'pointer',
                                  fontSize: 14,
                                  transition: 'all 0.15s'
                                }}
                              >
                                {slotStart} – {slotEnd}
                                {slot.note ? <span style={{ marginLeft: 6, fontSize: 11, color: '#667085' }}>({slot.note})</span> : null}
                              </button>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="row">
                      <div className="col-md-6">
                        <label className="form-label">
                          Start Time <span className="text-danger">*</span>
                        </label>
                        <input
                          type="time"
                          name="startTime"
                          className="form-control"
                          value={onlineBookingData.startTime}
                          onChange={handleOnlineBookingChange}
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">
                          End Time <span className="text-danger">*</span>
                        </label>
                        <input
                          type="time"
                          name="endTime"
                          className="form-control"
                          value={onlineBookingData.endTime}
                          onChange={handleOnlineBookingChange}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="cancelText"
                    onClick={handleCloseOnlineBookingModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="bgBtn"
                    onClick={confirmOnlineBooking}
                  >
                    Add Appointment
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ NEW: Patient Selection Modal (New vs Existing) */}
        {bookingTypeModal && (
          <div
            className="modal fade show"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          >
            <div className="modal-dialog modal-sm modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Patient Selection</h5>
                  <button type="button" className="btn-close" onClick={() => setBookingTypeModal(false)}></button>
                </div>
                <div className="modal-body p-4">
                  <div className="form-check mb-3">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="patientType"
                      id="newPatient"
                      onChange={() => handleBookingTypeSelection("new")}
                      style={{ cursor: "pointer", width: "20px", height: "20px" }}
                    />
                    <label className="form-check-label ms-2 fs-5" htmlFor="newPatient" style={{ cursor: "pointer" }}>
                      New Patient
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="patientType"
                      id="existingPatient"
                      onChange={() => handleBookingTypeSelection("existing")}
                      style={{ cursor: "pointer", width: "20px", height: "20px" }}
                    />
                    <label className="form-check-label ms-2 fs-5" htmlFor="existingPatient" style={{ cursor: "pointer" }}>
                      Existing Patient
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ✅ NEW: Patient Search/Select Modal */}
        {patientSearchModal && (
          <div
            className="modal fade show"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Select Patient</h5>
                  <button type="button" className="btn-close" onClick={() => setPatientSearchModal(false)}></button>
                </div>
                <div className="modal-body">
                  <div className="mb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by Name, Phone, or Civil ID..."
                      value={patientSearchTerm}
                      onChange={(e) => setPatientSearchTerm(e.target.value)}
                    />
                  </div>
                  <div className="table-responsive" style={{ maxHeight: "400px", maxWidth: "100%", overflowX: "auto" }}>
                    <table className="table table-hover" style={{ tableLayout: "fixed", width: "100%" }}>
                      <thead className="sticky-top bg-white">
                        <tr>
                          <th style={{ width: "35%", maxWidth: "200px" }}>Name</th>
                          <th style={{ width: "25%", maxWidth: "120px" }}>Phone</th>
                          <th style={{ width: "25%", maxWidth: "120px" }}>Civil ID</th>
                          <th style={{ width: "15%", maxWidth: "80px", textAlign: "center" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {allPatients
                          ?.filter(p =>
                            `${p.firstName} ${p.lastName}`.toLowerCase().includes(patientSearchTerm.toLowerCase()) ||
                            p.mobileNumber?.toString().includes(patientSearchTerm) ||
                            p.civilIdNumber?.toString().includes(patientSearchTerm)
                          )
                          .map(patient => (
                            <tr key={patient.id}>
                              <td style={{ maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                                {patient.firstName} {patient.lastName}
                              </td>
                              <td style={{ maxWidth: "120px" }}>{patient.mobileNumber}</td>
                              <td style={{ maxWidth: "120px" }}>{patient.civilIdNumber}</td>
                              <td style={{ textAlign: "center" }}>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => handleSelectExistingPatient(patient)}
                                  style={{ whiteSpace: "nowrap" }}
                                >
                                  Select
                                </button>
                              </td>
                            </tr>
                          ))
                        }
                        {allPatients?.length === 0 && (
                          <tr>
                            <td colSpan="4" className="text-center py-3">No patients found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Doctor Week Availability Modal ── */}
        {doctorWeekModal && (
          <div
            style={{ position: 'fixed', inset: 0, zIndex: 1060, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
            onClick={() => setDoctorWeekModal(false)}
          >
            <div
              style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 860, maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 12px 48px rgba(0,0,0,0.22)' }}
              onClick={e => e.stopPropagation()}
            >
              {/* Header */}
              <div style={{ padding: '16px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 14 }}>
                {/* Doctor photo */}
                <img
                  src={doctorWeekInfo?.doctor?.personalPhoto && doctorWeekInfo.doctor.personalPhoto !== 'null'
                    ? `${baseurImage}${doctorWeekInfo.doctor.personalPhoto}`
                    : '/assets/images/user/avatar-1.jpg'}
                  onError={e => { e.target.src = '/assets/images/user/avatar-1.jpg'; }}
                  alt=""
                  style={{ width: 52, height: 52, borderRadius: '50%', objectFit: 'cover', border: '2px solid #2CA87F', flexShrink: 0 }}
                />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 15, fontWeight: 700, color: '#1a202c' }}>{doctorWeekInfo?.doctor?.displayName || doctorWeekInfo?.doctor?.fullName || '—'}</div>
                  {doctorWeekInfo?.doctor?.specialty && <div style={{ fontSize: 12, color: '#5B6B79', marginTop: 1 }}>{doctorWeekInfo.doctor.specialty}</div>}
                  <div style={{ fontSize: 11, color: '#2CA87F', marginTop: 3, fontWeight: 600 }}>7-Day Availability</div>
                </div>
                <button
                  onClick={() => setDoctorWeekModal(false)}
                  style={{ width: 30, height: 30, borderRadius: 8, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15, flexShrink: 0 }}
                ><i className="ti ti-x" /></button>
              </div>

              {/* Body */}
              <div style={{ overflowY: 'auto', padding: '18px 20px' }}>
                {doctorWeekLoading ? (
                  <div style={{ textAlign: 'center', padding: '40px 0', color: '#9aa0ac', fontSize: 13 }}>Loading schedule…</div>
                ) : (
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 10 }}>
                    {(doctorWeekInfo?.days || []).map((day, di) => {
                      const dateStr = day.format('YYYY-MM-DD');
                      const dayEntries = (doctorWeekInfo?.schedule || []).filter(e => (e.schedule_date || '').slice(0, 10) === dateStr);
                      const isDayOffDay = dayEntries.some(e => e.is_day_off);
                      const shifts = isDayOffDay ? [] : dayEntries.filter(e => !e.is_day_off);
                      const hasSchedule = dayEntries.length > 0;
                      const isToday = di === 0;

                      // Booked appointments for this day
                      const dayAppts = (doctorWeekInfo?.appointments || []).filter(a => {
                        const d = a.appointmentDate || a.date || '';
                        return (d || '').slice(0, 10) === dateStr;
                      });

                      // Compute free 10-min slots within shifts
                      let freeCount = 0;
                      let totalSlotCount = 0;
                      shifts.forEach(shift => {
                        const sStart = toMins(shift.start_time);
                        const sEnd = toMins(shift.end_time);
                        const totalSlots = Math.floor((sEnd - sStart) / 10);
                        const bookedMins = dayAppts.reduce((acc, a) => {
                          const aStart = toMins(a.startTime || a.appointmentStartTime);
                          const aEnd = toMins(a.endTime || a.appointmentEndTime);
                          const overlapStart = Math.max(aStart, sStart);
                          const overlapEnd = Math.min(aEnd, sEnd);
                          return acc + Math.max(0, Math.floor((overlapEnd - overlapStart) / 10));
                        }, 0);
                        totalSlotCount += totalSlots;
                        freeCount += Math.max(0, totalSlots - bookedMins);
                      });

                      return (
                        <div key={di} style={{
                          borderRadius: 10,
                          border: `1.5px solid ${isToday ? '#2CA87F' : '#e8ecf0'}`,
                          background: isToday ? '#f0faf6' : '#fafbfc',
                          padding: '10px 10px 12px',
                          display: 'flex',
                          flexDirection: 'column',
                          gap: 6,
                          minHeight: 140,
                        }}>
                          {/* Day header */}
                          <div style={{ textAlign: 'center' }}>
                            <div style={{ fontSize: 10, fontWeight: 700, color: isToday ? '#2CA87F' : '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                              {day.format('ddd')}{isToday && ' · Today'}
                            </div>
                            <div style={{ fontSize: 18, fontWeight: 700, color: isToday ? '#2CA87F' : '#1a202c', lineHeight: 1.2 }}>{day.format('D')}</div>
                            <div style={{ fontSize: 10, color: '#9aa0ac' }}>{day.format('MMM')}</div>
                          </div>

                          {/* Content */}
                          {!hasSchedule ? (
                            <div style={{ textAlign: 'center', marginTop: 'auto', paddingTop: 8 }}>
                              <div style={{ fontSize: 10, color: '#c0c7d0', fontStyle: 'italic' }}>No schedule</div>
                            </div>
                          ) : isDayOffDay ? (
                            <div style={{ marginTop: 'auto', textAlign: 'center' }}>
                              <span style={{ fontSize: 10, fontWeight: 600, color: '#842029', background: '#fff3f3', border: '1px solid #f5c2c7', borderRadius: 5, padding: '3px 8px', display: 'inline-block' }}>
                                <i className="ti ti-calendar-off me-1" />Day Off
                              </span>
                            </div>
                          ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 4 }}>
                              {/* Shifts */}
                              {shifts.map((s, si) => (
                                <div key={si} style={{ background: '#e8f7f2', border: '1px solid #b7e4cf', borderRadius: 5, padding: '3px 6px', fontSize: 9.5, color: '#1a7a5c', fontWeight: 600, textAlign: 'center' }}>
                                  {(() => {
                                    const fmt = t => { if (!t) return ''; const [h, m] = t.slice(0,5).split(':').map(Number); return `${h % 12 || 12}:${m.toString().padStart(2,'0')} ${h < 12 ? 'AM' : 'PM'}`; };
                                    return `${fmt(s.start_time)} – ${fmt(s.end_time)}`;
                                  })()}
                                </div>
                              ))}
                              {/* Booked count */}
                              {dayAppts.length > 0 && (
                                <div style={{ fontSize: 10, color: '#9E2B25', textAlign: 'center', marginTop: 2 }}>
                                  <i className="ti ti-calendar-event me-1" />{dayAppts.length} booked
                                </div>
                              )}
                              {/* Free slots */}
                              {totalSlotCount > 0 && (
                                <div style={{ fontSize: 10, fontWeight: 700, color: freeCount > 0 ? '#2CA87F' : '#9aa0ac', textAlign: 'center' }}>
                                  {freeCount > 0 ? `${freeCount} slots free` : 'Fully booked'}
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                )}

                {/* Legend */}
                {!doctorWeekLoading && (
                  <div style={{ display: 'flex', gap: 16, marginTop: 16, fontSize: 11, color: '#9aa0ac', flexWrap: 'wrap' }}>
                    <span><span style={{ display: 'inline-block', width: 10, height: 10, borderRadius: 3, background: '#e8f7f2', border: '1px solid #b7e4cf', marginRight: 4 }} />Shift hours</span>
                    <span style={{ color: '#2CA87F', fontWeight: 600 }}><i className="ti ti-circle-check me-1" />Free slots = 10-min intervals</span>
                    <span style={{ color: '#9E2B25' }}><i className="ti ti-calendar-event me-1" />Booked = confirmed appointments</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {openmodal && (() => {
          const isBookedSlot = (slot) => {
            const slotMin = toMins(slot);
            const slotEnd = slotMin + 10;
            return bookModalBookedSlots.some(({ startTime, endTime }) => {
              if (!startTime || !endTime) return false;
              const bStart = toMins(startTime.substring(0, 5));
              const bEnd = toMins(endTime.substring(0, 5));
              return slotMin < bEnd && slotEnd > bStart;
            });
          };
          const isPastSlot = (slot) => {
            if (dataConfirm?.date !== dayjs().format('YYYY-MM-DD')) return false;
            const now = dayjs();
            return toMins(slot) < now.hour() * 60 + now.minute();
          };
          const isInRange = (slot) => {
            if (!dataConfirm?.startTime || !dataConfirm?.endTime) return false;
            const slotMin = toMins(slot);
            return slotMin >= toMins(dataConfirm.startTime) && slotMin < toMins(dataConfirm.endTime);
          };
          const handleSlotClick = (slot) => {
            if (isBookedSlot(slot) || isPastSlot(slot)) return;
            const startMin = toMins(slot);
            const endMin = Math.min(startMin + 30, 23 * 60 + 50);
            setDataConfirm(prev => ({ ...prev, startTime: slot, endTime: fromMins(endMin) }));
          };
          const sLabel = (text) => (
            <div style={{ fontSize: 11, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.07em', marginBottom: 10, paddingBottom: 6, borderBottom: '1px solid #f0f2f5' }}>{text}</div>
          );
          const fLabel = (text, req) => (
            <label style={{ fontSize: 12, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>{text}{req && <span style={{ color: '#e74c3c', marginLeft: 2 }}>*</span>}</label>
          );
          const durMins = dataConfirm?.startTime && dataConfirm?.endTime
            ? toMins(dataConfirm.endTime) - toMins(dataConfirm.startTime)
            : null;
          return (
            <div style={{ position: 'fixed', inset: 0, zIndex: 10000, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
              <div style={{ background: '#fff', borderRadius: 14, border: '1px solid #e8ecf0', width: '100%', maxWidth: 620, maxHeight: '92vh', display: 'flex', flexDirection: 'column', boxShadow: '0 8px 40px rgba(0,0,0,0.18)', overflow: 'hidden' }}>

                {/* Header */}
                <div style={{ padding: '14px 20px', borderBottom: '1px solid #e8ecf0', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                  <div style={{ width: 32, height: 32, borderRadius: 8, background: '#2CA87F15', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <i className="ti ti-calendar-check" style={{ color: '#2CA87F', fontSize: 17 }} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>Book Appointment</div>
                    <div style={{ fontSize: 11, color: '#5B6B79' }}>
                      {waitingItem?.patientName
                        ? <>Scheduling for <strong>{waitingItem.patientName}</strong></>
                        : 'Set time slot to confirm appointment'}
                    </div>
                  </div>
                  <button onClick={handleclose22}
                    style={{ width: 28, height: 28, borderRadius: 7, border: '1px solid #e8ecf0', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 15 }}
                    onMouseEnter={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#dc2626'; }}
                    onMouseLeave={e => { e.currentTarget.style.background = '#f8f9fb'; e.currentTarget.style.color = '#5B6B79'; }}
                  ><i className="ti ti-x" /></button>
                </div>

                {/* Body */}
                <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>

                  {/* Doctor & Date */}
                  {sLabel('Doctor & Date')}
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 22 }}>
                    <div>
                      {fLabel('Doctor', true)}
                      <select
                        name="doctorId"
                        value={dataConfirm?.doctorId || ''}
                        onChange={handlechange}
                        style={{ height: 36, fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 8, padding: '0 10px', width: '100%', outline: 'none', color: '#374151', background: '#fff' }}
                      >
                        <option value="">Select doctor…</option>
                        {doctorsdata && doctorsdata.map((d) => (
                          <option key={d.id} value={String(d.id)}>{d.displayName}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      {fLabel('Date', true)}
                      <input
                        type="date"
                        name="date"
                        value={dataConfirm?.date || ''}
                        onChange={handlechange}
                        style={{ height: 36, fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 8, padding: '0 10px', width: '100%', outline: 'none', color: '#374151' }}
                      />
                    </div>
                  </div>

                  {/* Time Slot */}
                  {sLabel('Time Slot')}
                  <div style={{ border: '1px solid #e9ecef', borderRadius: 10, padding: '14px 16px', marginBottom: 22 }}>
                    {/* Mode toggle */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                      <div style={{ display: 'flex', borderRadius: 8, border: '1px solid #dee2e6', overflow: 'hidden' }}>
                        {[{ key: 'slots', label: 'Suggest Slots' }, { key: 'manual', label: 'Manual' }].map(({ key, label }) => (
                          <button key={key} type="button" onClick={() => setBookModalTimeMode(key)}
                            style={{ padding: '5px 14px', background: bookModalTimeMode === key ? '#2ca87f' : '#fff', color: bookModalTimeMode === key ? '#fff' : '#666', border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: bookModalTimeMode === key ? 600 : 400, transition: 'background 0.15s' }}
                          >{label}</button>
                        ))}
                      </div>
                      {bookModalLoadingSlots && <span style={{ fontSize: 11, color: '#aaa' }}>Loading…</span>}
                      {durMins !== null && durMins > 0 && (
                        <span style={{ fontSize: 11, color: '#2ca87f', fontWeight: 600, marginLeft: 'auto' }}>
                          <i className="ti ti-clock me-1" />{durMins} min
                        </span>
                      )}
                    </div>

                    {bookModalTimeMode === 'slots' && (
                      !dataConfirm?.doctorId || !dataConfirm?.date
                        ? <p style={{ color: '#bbb', fontSize: 12, margin: '4px 0 10px' }}>Select a doctor and date to see available slots.</p>
                        : <>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, maxHeight: 160, overflowY: 'auto', paddingBottom: 4 }}>
                            {bookAllTimeSlots.map((slot) => {
                              const booked = isBookedSlot(slot);
                              const past = isPastSlot(slot);
                              const disabled = booked || past;
                              const inRange = isInRange(slot);
                              const isStart = slot === dataConfirm?.startTime;
                              return (
                                <button key={slot} type="button" disabled={disabled} onClick={() => handleSlotClick(slot)}
                                  title={booked ? 'Already booked' : past ? 'Time has passed' : `Select ${toAmPmW(slot)}`}
                                  style={{ padding: '3px 9px', borderRadius: 5, border: `1.5px solid ${disabled ? '#e9ecef' : inRange ? '#2ca87f' : '#ddd'}`, background: disabled ? '#f8f9fa' : isStart ? '#2ca87f' : inRange ? '#e6f4ef' : '#fff', color: disabled ? '#ccc' : isStart ? '#fff' : inRange ? '#2ca87f' : '#444', fontSize: 11, cursor: disabled ? 'not-allowed' : 'pointer', fontWeight: isStart ? 700 : 400, textDecoration: booked ? 'line-through' : 'none', transition: 'all 0.1s' }}
                                >{toAmPmW(slot)}</button>
                              );
                            })}
                          </div>
                          <div style={{ display: 'flex', gap: 12, marginTop: 6, fontSize: 10, color: '#999' }}>
                            <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: '#2ca87f', marginRight: 3 }} />Start</span>
                            <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: '#e6f4ef', border: '1px solid #2ca87f', marginRight: 3 }} />Duration</span>
                            <span><span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: 2, background: '#f8f9fa', border: '1px solid #e9ecef', marginRight: 3 }} />Booked / Past</span>
                          </div>
                        </>
                    )}

                    {/* Start / End time inputs */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginTop: 14 }}>
                      <div>
                        {fLabel('Start Time', true)}
                        <input type="time" name="startTime" value={dataConfirm?.startTime || ''} onChange={handlechange}
                          style={{ height: 36, fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 8, padding: '0 10px', width: '100%', outline: 'none', color: '#374151' }} />
                      </div>
                      <div>
                        {fLabel('End Time', true)}
                        <input type="time" name="endTime" value={dataConfirm?.endTime || ''} onChange={handlechange}
                          style={{ height: 36, fontSize: 13, border: '1px solid #d0d5dd', borderRadius: 8, padding: '0 10px', width: '100%', outline: 'none', color: '#374151' }} />
                      </div>
                    </div>
                    {durMins !== null && durMins <= 0 && (
                      <div style={{ fontSize: 11, color: '#e74c3c', marginTop: 5 }}>End time must be after start time</div>
                    )}
                  </div>

                </div>

                {/* Footer */}
                <div style={{ padding: '14px 20px', borderTop: '1px solid #e8ecf0', display: 'flex', justifyContent: 'flex-end', gap: 10, flexShrink: 0, background: '#fafbfc', borderRadius: '0 0 14px 14px' }}>
                  <button type="button" className="cancelBtn" onClick={handleclose22}>Cancel</button>
                  <button type="button" className="bgBtn" onClick={BookingConfirm}>
                    <i className="ti ti-calendar-check me-1" />Confirm Booking
                  </button>
                </div>
              </div>
            </div>
          );
        })()}
      </div>

      {/* ── SMS Log Modal ─────────────────────────────────────────────── */}
      {smsLogOpen && (
        <div
          className="modal fade show"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">SMS Log</h5>
                <div className="d-flex gap-2 ms-3">
                  {["all", "sent", "failed"].map(f => (
                    <button
                      key={f}
                      className={smsLogFilter === f ? "bgBtn" : "borderBtn"}
                      style={{ padding: "3px 12px", fontSize: "13px", textTransform: "capitalize" }}
                      onClick={() => setSmsLogFilter(f)}
                    >
                      {f}
                    </button>
                  ))}
                </div>
              </div>
              <div className="modal-body" style={{ maxHeight: "65vh", overflowY: "auto" }}>
                {smsLogLoading ? (
                  <div className="text-center py-4">Loading…</div>
                ) : (
                  <table className="table table-striped table-sm">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Type</th>
                        <th>Template</th>
                        <th>Recipient</th>
                        <th>Mobile</th>
                        <th>Status</th>
                        <th>Sent At</th>
                        <th>Error</th>
                      </tr>
                    </thead>
                    <tbody>
                      {smsLogs
                        .filter(l => smsLogFilter === "all" || l.status === smsLogFilter)
                        .map((l, i) => (
                          <tr key={l.id}>
                            <td>{i + 1}</td>
                            <td style={{ whiteSpace: "nowrap" }}>{l.type}</td>
                            <td>{l.template_name || l.template_id}</td>
                            <td>{l.recipient_name}</td>
                            <td style={{ whiteSpace: "nowrap" }}>{l.recipient_mobile}</td>
                            <td>
                              <span
                                style={{
                                  padding: "2px 8px",
                                  borderRadius: 4,
                                  fontSize: 12,
                                  fontWeight: 600,
                                  background: l.status === "sent" ? "#d1fae5" : "#fee2e2",
                                  color: l.status === "sent" ? "#065f46" : "#991b1b",
                                }}
                              >
                                {l.status}
                              </span>
                            </td>
                            <td style={{ whiteSpace: "nowrap" }}>
                              {l.sent_at ? new Date(l.sent_at).toLocaleString() : "—"}
                            </td>
                            <td style={{ color: "#991b1b", fontSize: 12 }}>{l.error_message || ""}</td>
                          </tr>
                        ))}
                      {smsLogs.filter(l => smsLogFilter === "all" || l.status === smsLogFilter).length === 0 && (
                        <tr>
                          <td colSpan={8} className="text-center text-muted py-3">No records found.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="modal-footer">
                <button className="cancelText" onClick={() => setSmsLogOpen(false)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showNewAppointmentModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 10000,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: 16,
            overflowY: "auto",
          }}
          onClick={() => { setShowNewAppointmentModal(false); setNewAppointmentPrefill(null); }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: "#fff",
              borderRadius: 14,
              border: "1px solid #e8ecf0",
              width: "100%",
              maxWidth: 1100,
              maxHeight: "92vh",
              overflowY: "auto",
              boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
            }}
          >
            <AddAppointment
              isModal
              initialDoctorId={newAppointmentPrefill?.doctorId}
              initialDate={newAppointmentPrefill?.appointmentDate}
              initialStartTime={newAppointmentPrefill?.startTime}
              onClose={() => { setShowNewAppointmentModal(false); setNewAppointmentPrefill(null); }}
              onSuccess={() => { getCalendarData(); waitingAppointmentList1(); }}
            />
          </div>
        </div>
      )}

      <ToastContainer />
    </div>
  );
}
